var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h1200v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 300h600V0h600v600H0z",
    fill: "#012169"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h600v300H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v33.54L532.92 300H600v-33.54L67.08 0zm600 0v33.54L67.08 300H0v-33.54L532.92 0z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M250 0v300h100V0zM0 100v100h600V100z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 120v60h600v-60zM270 0v300h60V0zM0 300l200-100h44.72l-200 100zM0 0l200 100h-44.72L0 22.36zm355.28 100 200-100H600L400 100zM600 300 400 200h44.72L600 277.64z",
    fill: "#c8102e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M745.184 486.528c-4.63-.734-8.635-2.82-13.112-7.464l-2.246-2.2-2.705.946c-14.12 4.756-30.754 8.054-50.575 8.386-25.732.43-47.829-3.359-60.754-8.988l-4.065-1.552-2.132 2.206c-4.677 5.045-9.381 7.601-14.738 8.009-5.1.388-12.08-2.146-15.595-5.661-1.445-1.446-1.685-1.947-2.362-4.938-.634-2.8-2.195-6.946-3.303-8.772-.503-.83-1.67-2.433-2.594-3.564-4.518-5.53-4.662-5.875-3.329-7.965 1.75-2.74 4.458-4.496 7.624-4.944 1.015-.144 1.898-.315 1.963-.38.065-.064-.373-.894-.972-1.844-1.58-2.502-2.617-4.642-2.355-4.863.125-.106 1.46-1.066 2.968-2.133 5.881-4.163 7.445-6.6 9.597-14.954.652-2.53 1.473-5.081 1.825-5.67 1.447-2.42 4.351-3.83 8.35-4.053 3.078-.173 4.646.165 7.96 1.714 6.549 3.062 13.274 8.642 18.836 15.629l2.396 3.01-.167 2.604c-.535 8.358-1.253 12.972-2.678 17.205-.53 1.572-.757 2.634-.597 2.79.376.366 7.945 2.672 11.815 3.599 5.986 1.434 13.315 2.561 21.61 3.323 5.2.478 24.816.477 29.743 0 7.968-.773 17.15-2.328 23.027-3.9 4.887-1.307 10.417-3.13 10.417-3.434 0-.18-.176-.748-.39-1.262-1.24-2.966-2.239-9.022-2.594-15.73l-.245-4.618 2.22-2.756c2.685-3.332 7.22-7.87 10.288-10.294 3.06-2.418 7.384-5.037 10.043-6.082 5.224-2.055 12.128-.905 14.462 2.41.413.587 1.534 3.227 2.491 5.865 3.099 8.546 4.418 10.399 10.12 14.219 1.169.783 2.125 1.613 2.125 1.844s-.864 2.124-1.92 4.204-1.918 3.86-1.918 3.956.533.174 1.184.174c3.525 0 7.92 2.738 9.41 5.862.58 1.216.37 1.961-1.067 3.812l-2.906 3.744c-2.43 3.134-3.953 6.158-5.118 10.157-1.581 5.428-1.656 5.586-3.462 7.257-1.9 1.76-6.158 3.944-9.018 4.628-2.266.541-5.738.756-7.557.468z",
    color: "#000",
    fill: "#500",
    stroke: "#500",
    strokeLinejoin: "round",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(15.723 -159.642) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(407.357 -335.206) scale(1.3183)",
    d: "m439.696 585.486 8.28-7.495c-.033-3.582-2.09-6.538-4.911-7.624-2.484-.956-4.867-1.014-7.708 2.082.3 5.647 1.282 8.512 4.34 13.037z",
    fill: "none",
    stroke: "#520",
    strokeLinejoin: "round",
    strokeWidth: 0.12,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(407.357 -335.206) scale(1.3183)",
    d: "m449.333 596.767 2.61 3.982c.58.11 1.17.213 1.76.317-.317 2.654 1.193 6.55 1.193 6.55s-10.292 5.711-15.52 8.493c-2.721-1.982-5.246-4.722-7.623-8.217l-2.58-4.123c2.548-.923 4.982-1.8 5.213-1.893.485-.194 11.752-4.662 11.752-4.662z",
    fill: "#951b1d",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(407.357 -335.206) scale(1.3183)",
    d: "M452.253 600.805c6.929 1.288 14.572 1.92 15.054 9.131.26 5.442-9.95 9.646-16.326 10.041-5.405.335-10.356-2.439-14.783-6.736 5.05-2.532 15.377-6.042 16.055-12.436z",
    fill: "#e2a950",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(407.357 -335.206) scale(1.3183)",
    d: "M467.308 609.936c.26 5.442-9.938 10.072-16.327 10.041-7.57-.037-13.787-4.086-19.228-12.086l-8.23-13.152c-3.967-6.309-4.574-15.8-4.817-24.343 4.764-6.375 10.186-12.468 18.54-17.305 4.228-2.39 8.573-4.509 14.834-2.197 4.11 1.447 5.1 4.455 5.63 7.691-.383 13.313-1.33 26.49-8.377 38.181l2.61 3.983c7.008 1.328 14.875 1.868 15.365 9.187z",
    fill: "none",
    stroke: "#520",
    strokeLinejoin: "round",
    strokeWidth: 0.12,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(407.357 -335.206) scale(1.3183)",
    d: "M436.655 579.616c.574 1.717 1.353 3.359 2.418 4.896-4.716 3.603-10.37 6.267-16.547 8.408-.046-.094-.09-.19-.135-.285-.233-.49-.448-.995-.652-1.512-.094-.238-.19-.475-.277-.718-.079-.217-.151-.44-.225-.66a31.79 31.79 0 0 1-.285-.89c-.03-.1-.058-.202-.088-.304 5.425-3.11 10.428-5.794 15.791-8.935z",
    fill: "#c98c26",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(407.357 -335.206) scale(1.3183)",
    d: "M460.094 602.414c3.893 1.14 6.916 3.078 7.213 7.522.26 5.442-9.937 10.072-16.326 10.04-3.004-.014-5.792-.672-8.406-1.946.244-.122 7.084-1.519 10.068-3.433 2.178-1.396 4.565-4.466 5.342-5.632.777-1.165 1.165-4.274 1.941-6.217.049-.12.105-.23.168-.334z",
    fill: "#ab1e2b",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(407.357 -335.206) scale(1.3183)",
    d: "M460.094 602.414c.665.195 1.307.409 1.91.659-.092 1.709 1.02 3.149.858 4.75-.137 1.349-.76 2.648-1.512 3.777a14.201 14.201 0 0 1-4.05 3.982c-1.775 1.155-3.868 1.763-5.907 2.334-2.08.584-3.283.57-6.388 1.1a19.23 19.23 0 0 1-2.43-.986c1.276-.712 3.531-.937 4.767-1.487 1.237-.549 2.953-1.166 4.395-1.99 1.442-.824 2.747-1.854 3.021-2.129.275-.274 2.54-2.885 2.747-3.228.206-.344 2.119-4.99 2.59-6.782z",
    fill: "#c47645",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(407.357 -335.206) scale(1.3183)",
    d: "M434.926 554.522a60.5 60.5 0 0 1 .143 2.223c.048 1.066.058 2.148.065 3.23.003.606.01 1.211.006 1.82-.006 1.013-.012 2.025-.02 3.04-.008.88 0 1.756.006 2.632.005.693.009 1.387.03 2.074.01.345.015.691.03 1.034.03.65.07 1.295.122 1.937v.014s-.08 4.715.774 7.11c.74 2.071 2.991 4.876 2.991 4.876l-10.476 5.822-6.063 2.584-.01.004c-.032-.065-.06-.133-.092-.199 0 0 0-.003-.002-.004-2.193-5.97-3.53-15.513-3.724-22.322 4.306-5.763 9.158-11.293 16.22-15.875z",
    fill: "#ca6b5b",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(407.357 -335.206) scale(1.3183)",
    d: "M435.061 563.082c-.002 1.092.062 5.529.096 6.608.03.948.074 1.89.15 2.822v.014l.002.004c.233 2.837.735 5.577 1.74 8.13l-16.142 8.04c-.004-.014-.007-.03-.012-.043l-.029-.102a36.06 36.06 0 0 1-.348-1.277l-.01-.033-.056-.233a39.015 39.015 0 0 1-.34-1.508c0-.004-.003-.008-.004-.011v-.002a.05.05 0 0 0-.002-.008l-.004-.018c-.058-.287-.107-.58-.16-.87a53.128 53.128 0 0 1-.531-3.524c-.03-.244-.06-.488-.086-.733a72.752 72.752 0 0 1-.172-1.662v-.006l-.002-.008-.004-.047-.004-.062a103.594 103.594 0 0 1-.24-3.393z",
    fill: "#e2b269",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(407.357 -335.206) scale(1.3183)",
    d: "M435.163 570.075c.096 2.646.348 5.236.955 7.695-4.582 2.157-13.028 6.28-16.01 7.709-.067-.328-.124-.664-.185-.996a53.337 53.337 0 0 1-.291-1.744c-.036-.234-.075-.466-.108-.702 0-.009-.003-.018-.004-.027-.006-.046-.009-.094-.015-.14a70.845 70.845 0 0 1-.35-3.16l-.022-.272z",
    fill: "#f2d196",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(407.357 -335.206) scale(1.3183)",
    d: "M438.364 583.364c.227.386.45.774.709 1.148-4.716 3.604-10.37 6.27-16.549 8.41a23.802 23.802 0 0 1-.707-1.601z",
    fill: "#951b1d",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(407.357 -335.206) scale(1.3183)",
    d: "M434.926 554.522c.91 10.17-1.655 21.614 4.147 29.99-4.716 3.604-10.37 6.27-16.549 8.41-3.067-6.23-3.597-14.764-3.818-22.525 4.306-5.763 9.158-11.293 16.22-15.875z",
    fill: "none",
    stroke: "#520",
    strokeLinejoin: "round",
    strokeWidth: 0.12,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(407.357 -335.206) scale(1.3183)",
    d: "M448.407 576.66c.87-.89 2.09-2.317 3.084-3.61 2.679-3.48 4.66-7.182 5.624-10.508.34-1.169.448-1.836.485-2.987.033-.985.031-1.007-.117-1.748-.462-2.307-1.149-3.773-2.308-4.927-.958-.955-1.958-1.523-3.715-2.109-1.747-.583-3.26-.815-4.977-.766-2.704.078-5.025.843-8.62 2.84-.875.487-2.547 1.492-2.764 1.661-.085.067-.09.11-.05.535.14 1.53.162 2.76.166 8.813.003 4.533.021 6.545.067 7.283.034.561.073 1.052.086 1.09.015.047.176-.08.494-.392.745-.73 1.328-1.162 2.074-1.535 1.54-.77 3.124-.78 5.078-.035 2.047.781 3.674 2.468 4.483 4.648.195.524.391 1.286.444 1.72.018.156.048.31.066.343.021.04.158-.069.4-.316z",
    fill: "#faecbd",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(407.357 -335.206) scale(1.3183)",
    d: "M436.045 571.625c.998-.937 2.197-1.617 3.21-1.82.38-.075.395-.086.394-.292 0-.118.203-4.195.453-9.06.25-4.866.437-8.864.415-8.886-.094-.094-3.657 1.827-4.997 2.694-.53.343-.503.253-.396 1.303.038.378.097 4.163.131 8.412.034 4.25.082 7.826.107 7.95.026.122.066.22.09.219.024-.002.29-.236.593-.52z",
    fill: "#ae4c33",
    strokeWidth: 0.008,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(407.357 -335.206) scale(1.3183)",
    d: "M443.254 570.257c0-.033.614-4.58 1.365-10.105.75-5.525 1.346-10.065 1.322-10.089-.087-.087-1.788.19-2.59.422a25.65 25.65 0 0 0-1.82.627l-.997.39v.63c0 .654-.727 15.673-.818 16.902l-.052.698.333-.054c.464-.075 1.76.13 2.574.406.376.127.683.205.683.173z",
    fill: "#dba35a",
    strokeWidth: 0.012,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(407.357 -335.206) scale(1.3183)",
    d: "M449.144 575.79c3.143-3.535 5.418-6.981 6.918-10.481 1.407-3.282 1.792-5.812 1.235-8.113-.872-3.597-2.47-5.314-5.99-6.436-1.455-.463-2.777-.698-4.064-.722-.632-.012-1.17 0-1.194.027-.025.027-.512 3.545-1.082 7.818-.57 4.273-1.18 8.818-1.355 10.1l-.317 2.331.588.316c2.014 1.08 3.458 3.066 3.988 5.487.09.414.198.752.239.752.04 0 .506-.486 1.034-1.08z",
    fill: "#e9be79",
    strokeWidth: 0.012,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1340.416 242.171 4.143-3.15 1.988-1.76s1.014-.577.902-1.05c-.65-2.735-2.409-4.841-4.793-5.738-2.632-.991-4.699-.564-6.79 1.402l-.775.729.107 1.068c.403 3.993 1.2 7.032 2.898 9.818.269.44 1.033-.392 1.075-.392.04 0 1.244-.927 1.244-.927z",
    fill: "#012169",
    stroke: "#500",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(-778.766 112.853) scale(1.3183)"
  })), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m307.61 584.807-8.28-7.495c.034-3.581 2.091-6.538 4.912-7.623 2.484-.956 4.867-1.015 7.708 2.082-.3 5.647-1.282 8.512-4.34 13.036z",
    fill: "none",
    stroke: "#520",
    strokeLinejoin: "round",
    strokeWidth: 0.12,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(407.485 -335.334) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.974 596.088-2.61 3.983c-.58.11-1.17.213-1.76.316.317 2.655-1.193 6.551-1.193 6.551s10.292 5.71 15.52 8.492c2.721-1.982 5.246-4.722 7.623-8.217l2.58-4.123c-2.549-.922-4.982-1.8-5.213-1.892-.485-.194-11.752-4.662-11.752-4.662z",
    fill: "#951b1d",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(407.485 -335.334) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.054 600.127c-6.929 1.288-14.572 1.92-15.054 9.13-.26 5.443 9.95 9.646 16.326 10.042 5.405.335 10.356-2.44 14.783-6.737-5.05-2.531-15.377-6.041-16.055-12.435z",
    fill: "#e2a950",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(407.485 -335.334) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 609.258c-.26 5.441 9.937 10.072 16.326 10.04 7.57-.036 13.787-4.085 19.228-12.085l8.23-13.152c3.967-6.31 4.574-15.8 4.817-24.343-4.764-6.375-10.186-12.469-18.54-17.305-4.229-2.39-8.573-4.509-14.834-2.198-4.11 1.448-5.1 4.455-5.63 7.692.383 13.313 1.33 26.489 8.377 38.18l-2.61 3.984c-7.008 1.328-14.875 1.868-15.365 9.187z",
    fill: "none",
    stroke: "#520",
    strokeLinejoin: "round",
    strokeWidth: 0.12,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(407.485 -335.334) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.652 578.937c-.574 1.717-1.353 3.36-2.418 4.897 4.716 3.603 10.37 6.267 16.547 8.408.046-.094.09-.19.135-.285.233-.49.448-.996.652-1.512.094-.239.19-.475.277-.719.079-.217.151-.44.225-.66.098-.294.195-.589.285-.889.03-.1.058-.203.088-.304-5.425-3.11-10.428-5.794-15.791-8.936z",
    fill: "#c98c26",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(407.485 -335.334) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.596 557.907c-1.955 12.235-7.678 15.05-13.185 18.404 0 0 17.45 43.08 97.514 42.576 68.108 0 89.796-26.185 96.689-43.675-11.508-6.316-10.48-11.667-13.185-17.305 2.529 11.292-21.91 41.968-83.23 42.026-71.679.069-85.574-35.615-84.603-42.026z",
    fill: "#eed3a6",
    stroke: "#520",
    strokeLinejoin: "round",
    strokeWidth: 0.12,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(407.485 -335.334) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.47 563.388-.388.711c-4.755 9.794-9.874 13.724-16.54 18.711-8.207 6.141-18.107 9.854-27.851 13.037-6.65 2.173-13.648 3.233-20.598 4.04-10.041 1.165-20.202 1.498-30.304 1.132a137.647 137.647 0 0 1-20.047-2.207c-5.631-1.042-11.17-2.589-16.617-4.357-4.494-1.46-8.986-3.028-13.21-5.147-4.784-2.4-13.618-8.506-13.618-8.506l-7.868-8.546-4.433-8.069c-2.643 7.09-7.18 9.44-11.584 12.123 0 0 17.45 43.08 97.513 42.576 68.109 0 89.795-26.183 96.688-43.673-7.746-4.252-9.794-8.066-11.143-11.825z",
    fill: "#e6ba74",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(407.485 -335.334) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.996 564.185c-2.643 7.09-7.179 9.442-11.584 12.125 0 0 5.806 14.255 25.957 26.27-.266-2.536-1.586-13.763-1.586-14.203 0-.486-.001-7.186-.584-7.575-.583-.388-7.574-7.964-7.865-8.546-.203-.405-2.741-5.07-4.338-8.07z",
    fill: "#e2a950",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(407.485 -335.334) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.532 570.57c2.082 1.932 4.41 3.244 6.705 4.641 0 0-.96 4.7-5.49 10.258-.45-.93-1.496-2.404-1.496-2.56 0-.486-.875-3.788-.875-4.662 0-.874.195-4.953.195-5.827 0-.222.39-.929.961-1.85z",
    fill: "#c98c26",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(407.485 -335.334) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.596 557.907c-1.955 12.235-7.678 15.05-13.185 18.404 0 0 17.45 43.08 97.514 42.576 68.108 0 89.796-26.185 96.689-43.675-11.508-6.316-10.48-11.667-13.185-17.305 2.529 11.292-21.91 41.968-83.23 42.026-71.679.069-85.574-35.615-84.603-42.026z",
    fill: "none",
    stroke: "#520",
    strokeLinejoin: "round",
    strokeWidth: 0.12,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(407.485 -335.334) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.213 601.736c-3.893 1.14-6.916 3.078-7.213 7.521-.26 5.442 9.937 10.073 16.326 10.041 3.004-.014 5.792-.672 8.406-1.947-.244-.122-7.084-1.518-10.068-3.432-2.179-1.397-4.565-4.467-5.342-5.632-.777-1.166-1.165-4.275-1.942-6.217a2.192 2.192 0 0 0-.167-.334z",
    fill: "#ab1e2b",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(407.485 -335.334) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(763.551 -306.847) scale(1.3183)",
    d: "M17.12 580.127c-.665.194-1.307.408-1.911.658.093 1.71-1.02 3.15-.857 4.75.136 1.35.76 2.649 1.511 3.778a14.201 14.201 0 0 0 4.051 3.982c1.775 1.154 3.868 1.762 5.906 2.334 2.08.583 3.283.569 6.389 1.1.827-.272 1.636-.6 2.43-.987-1.277-.711-3.532-.937-4.768-1.486-1.236-.55-2.952-1.166-4.394-1.99-1.443-.824-2.747-1.855-3.022-2.13-.275-.274-2.54-2.884-2.746-3.228-.206-.343-2.12-4.99-2.59-6.781z",
    fill: "#c47645",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.38 553.843a61.094 61.094 0 0 0-.142 2.223 82.278 82.278 0 0 0-.065 3.23c-.003.607-.01 1.212-.006 1.82.006 1.014.012 2.026.02 3.04.008.881-.001 1.756-.006 2.633-.005.693-.01 1.386-.03 2.074-.01.345-.015.69-.03 1.033-.03.65-.07 1.296-.122 1.938v.013s.08 4.715-.774 7.11c-.74 2.072-2.991 4.877-2.991 4.877l10.476 5.822 6.063 2.584c.003 0 .006.003.01.004.032-.065.06-.134.092-.2 0 0 0-.002.002-.003 2.193-5.97 3.53-15.513 3.724-22.323-4.306-5.763-9.158-11.293-16.22-15.875z",
    fill: "#ca6b5b",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(407.485 -335.334) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.245 562.403c.002 1.093-.06 5.53-.095 6.608a56.01 56.01 0 0 1-.15 2.823v.013l-.002.004c-.233 2.838-.735 5.577-1.74 8.131l16.142 8.04c.004-.015.007-.03.012-.044l.029-.101c.123-.42.239-.846.348-1.278l.01-.033.056-.232c.121-.497.236-1 .34-1.508 0-.004.003-.008.004-.012v-.002a.05.05 0 0 1 .002-.008l.004-.017c.058-.287.107-.58.16-.87a53.128 53.128 0 0 0 .531-3.525 72.752 72.752 0 0 0 .258-2.395v-.005l.002-.008.004-.047.004-.063c.1-1.128.179-2.26.24-3.392z",
    fill: "#e2b269",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(407.485 -335.334) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.144 569.396c-.096 2.647-.348 5.236-.955 7.695 4.582 2.158 13.028 6.281 16.01 7.71.067-.329.124-.664.185-.997.106-.576.204-1.156.291-1.744.036-.234.075-.465.108-.701 0-.009.003-.018.004-.027.006-.047.009-.094.015-.14.141-1.043.255-2.099.35-3.161l.022-.272z",
    fill: "#f2d196",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(407.485 -335.334) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.255 571.764c-2.082 1.93-4.41 3.243-6.705 4.64 0 0 1.639 4.02 6.17 9.578.45-.93.816-1.724.816-1.88 0-.486.875-3.789.875-4.663 0-.874-.195-4.952-.195-5.826 0-.222-.39-.93-.961-1.85z",
    fill: "#c98c26",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(407.485 -335.334) scale(1.3183)"
  })), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(407.485 -335.334) scale(1.3183)",
    d: "m288.545 612.172-3.756-11.071 6.73 3.777.893 2.06-.206 1.923-.412 1.304-.962 1.03z",
    fill: "#f9e7d9",
    stroke: "#500",
    strokeLinejoin: "round",
    strokeWidth: 0.12,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.738 673.714c-.682 1.023-.14 1.461 0 2.091 0 0 4.514 4.678 6.098 7.44 1.28 2.232 2.65 7.2 2.65 7.2-.388-1.787 3.058-4.638 5.551-4.826 1.938-.147 4.506 1.232 4.879 3.057.34 1.664-.852 3.765-3.028 4.183 5.883-1.273 2.944-6.706 1.85-9.211 0 0-1.71-2.848-2.271-4.389-1.103-3.028-2.103-9.406-2.103-9.406-7.117-2.584-10.923-.19-13.626 3.86z",
    fill: "#e6ba74",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.5221 0 0 1.5916 -108.474 -631.053)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(763.551 -306.847) scale(1.3183)",
    d: "M8.877 561.5c-3.06.123-5.352 1.456-7.203 3.48 3.15 5.446 8.078 13.62 8.078 13.62l-5.77-13.598c2.207-2.44 4.999-2.832 8.24-1.648l-.19-1.577c-1.133-.218-2.187-.316-3.155-.277z",
    fill: "#f9e7d9",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(763.551 -306.847) scale(1.3183)",
    d: "M12.578 561.88c.85 5.9 2.205 15.955 2.766 20.13.331-.095.66-.163.972-.188 2.238-.177 5.202 1.487 5.631 3.69.354 1.813-.734 4.051-2.797 4.842 5.814-1.832 2.654-8.003 1.438-10.913 0 0-1.973-3.437-2.621-5.298-1.273-3.656-2.428-11.356-2.428-11.356a22.192 22.192 0 0 0-2.96-.906zm6.572 28.474c-.228.071-.443.15-.699.208.245-.049.477-.123.7-.208z",
    fill: "#c47645",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(763.551 -306.847) scale(1.3183)",
    d: "m13.283 562.068 4.307 19.85c1.959.367 4.006 1.79 4.357 3.594.354 1.813-.734 4.051-2.797 4.842 5.814-1.832 2.654-8.003 1.438-10.913 0 0-1.973-3.437-2.621-5.298-1.273-3.656-2.428-11.356-2.428-11.356-.79-.3-1.534-.527-2.256-.719z",
    fill: "#ab1e2b",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.738 673.714c-.682 1.023-.14 1.461 0 2.091 0 0 4.514 4.678 6.098 7.44 1.28 2.232 2.65 7.2 2.65 7.2-.388-1.787 3.058-4.638 5.551-4.826 1.938-.147 4.506 1.232 4.879 3.057.34 1.664-.852 3.765-3.028 4.183 5.883-1.273 2.944-6.706 1.85-9.211 0 0-1.71-2.848-2.271-4.389-1.103-3.028-2.103-9.406-2.103-9.406-7.117-2.584-10.923-.19-13.626 3.86z",
    fill: "none",
    stroke: "#520",
    strokeLinejoin: "round",
    strokeWidth: 0.102,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.5221 0 0 1.5916 -108.474 -631.053)"
  })), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(763.551 -306.847) scale(1.3183)",
    d: "M38.85 561.076c-.227.386-.45.774-.71 1.149 4.717 3.603 10.371 6.269 16.55 8.41a23.65 23.65 0 0 0 .706-1.602z",
    fill: "#951b1d",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.38 553.843c-.909 10.17 1.656 21.615-4.146 29.99 4.716 3.604 10.37 6.27 16.549 8.41 3.067-6.229 3.597-14.763 3.818-22.525-4.306-5.763-9.158-11.293-16.22-15.875z",
    fill: "none",
    stroke: "#520",
    strokeLinejoin: "round",
    strokeWidth: 0.12,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(407.485 -335.334) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(763.551 -306.847) scale(1.3183)",
    d: "M176.73 559.633c-28.398 20.027-93.966 31.508-139.212 3.566l.216 20.797c14.798 7.514 36.033 13.47 66.098 13.281 35.165 0 57.933-6.985 72.701-16.144z",
    fill: "#faecbd",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": "DESIRE THE RIGHT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.943 717.063q-1.155 1.922-3.093 2.333-1.878.397-3.826-.74l-2.231-1.314q.9-.818 1.893-2.47l1.87-3.11q.904-1.506 1.418-3.039l.88.529q5.72 3.434 3.09 7.81zm-1.406-.861q.965-1.604.523-3.127-.427-1.464-2.028-2.442l-4.055 6.746q3.739 1.853 5.56-1.177zm7.717 7.138-1.6 1.432-4.815-2.27q.798-.871 1.75-2.886l1.5-3.177q.708-1.498 1.045-3.03l5.002 2.359-1.39 1.137q-.694-.92-1.72-1.403-.13-.061-.655-.285l-1.394 2.951 2.976 1.403-1.538 1.067q-.64-.815-1.904-1.482l-1.495 3.164q1.681.651 2.08.76 1.06.31 2.158.26zm6.901 1.839q-.51 1.31-1.814 1.67-1.17.312-2.521-.213-.871-.338-1.588-1.114l.705-1.81q.222.729.48 1.106.345.493.943.726.659.255 1.286.04.67-.223.92-.869.262-.672-.36-1.71l-1.175-1.897q-.565-1.185-.166-2.21.47-1.204 1.644-1.567 1.082-.339 2.312.14.825.32 1.522.989l-.65 1.67q-.356-.72-.523-.939-.317-.406-.869-.62-.572-.223-1.074-.034-.527.194-.745.753-.249.638.376 1.67l1.168 1.917q.551 1.218.129 2.303zm3.629 4.157-2.119-.707q.746-1.151 1.145-2.343l1.428-4.267q.537-1.605.618-2.925l2.118.706q-.737 1.102-1.274 2.707l-1.405 4.199q-.421 1.26-.511 2.63zm10.106 2.96-1.751-.492q-1.284-2.045-2.468-5.442l-.38 1.347q-.464 1.642-.525 3.146l-2.15-.605q.626-.959 1.14-2.78l1.151-4.075q.348-1.23.44-2.821l1.066.3q2.033.572 2.922 1.26 1.385 1.079.894 2.818-.471 1.67-2.583 1.95.753 2.586 2.244 5.394zm-1.269-7.715q.495-1.753-1.723-2.562l-1.107 3.917q.998.17 1.713-.104.857-.33 1.117-1.251zm9.423 7.515-1.25 1.746-5.195-1.17q.59-1.023 1.082-3.196l.775-3.426q.365-1.616.361-3.183l5.396 1.214-1.11 1.412q-.877-.747-1.984-.996-.14-.031-.7-.136l-.72 3.183 3.21.722-1.27 1.376q-.803-.656-2.182-1.032l-.771 3.412q1.782.27 2.195.29 1.103.072 2.163-.216z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    transform: "matrix(1.60215 -.01667 .01796 1.62571 271.006 -711.78)",
    strokeWidth: 0.914
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.289 724.818-.603 1.69q-.791-.402-1.368-.535-.458-.106-1.455-.161l-.28 5.933q-.11 2.32.194 3.57l-2.366-.114q.423-1.093.541-3.595l.278-5.873q-1.16.02-1.723.069-.936.091-1.682.328l.656-1.688zm10.235 10.555-2.368.034q.343-1.276.33-2.116l-.04-2.663-4.556.066.021 1.362q.028 1.778.424 3.407l-2.369.035q.344-1.261.315-3.123l-.064-4.199q-.03-1.907-.415-3.331l2.368-.035q-.348 1.458-.33 2.593l.03 1.967 4.555-.066-.021-1.385q-.025-1.597-.412-3.165l2.368-.035q-.35 1.375-.323 3.078l.06 3.957q.034 2.164.427 3.619zm9.556-2.719-.738 2.152-5.631.385q.287-1.218.124-3.573l-.258-3.714q-.12-1.752-.603-3.342l5.851-.4-.697 1.769q-1.118-.492-2.319-.41-.15.01-.753.074l.239 3.45 3.48-.238-.87 1.781q-1.015-.423-2.53-.388l.256 3.7q1.893-.267 2.318-.372 1.143-.26 2.132-.874z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    transform: "matrix(1.60215 -.01667 .01796 1.62571 271.006 -711.78)",
    strokeWidth: 0.969
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.506 732.141-1.848.368q-2.149-1.283-4.842-3.86l.284 1.42q.347 1.733 1 3.149l-2.27.451q.126-1.178-.258-3.1l-.86-4.298q-.26-1.297-.924-2.808l1.124-.224q2.145-.427 3.289-.21 1.787.345 2.154 2.18.353 1.76-1.462 3.011 1.914 2.032 4.613 3.921zm-4.809-6.52q-.37-1.848-2.798-1.553l.827 4.132q1-.313 1.53-.9.635-.707.441-1.679zm8.706 5.471-2.24.577q0-1.42-.327-2.68l-1.166-4.509q-.44-1.696-1.114-2.889l2.24-.577q-.02 1.372.42 3.068l1.148 4.438q.344 1.33 1.04 2.572zm9.597-8.465q.014.846.152 1.44.085.368.436 1.405.362 1.072.738 1.702-1.61 1.19-3.234 1.737-2.297.774-4.124-.038-1.9-.843-2.668-3.12-.793-2.346.23-4.329 1.008-1.954 3.354-2.745 1.148-.387 2.641-.445l.576 1.702q-1.61-.472-3.116.035-1.604.54-2.156 2.045-.51 1.397.045 3.043.559 1.653 1.717 2.426 1.277.849 2.881.309.812-.274 1.847-1.09l-.431-1.276q-.402-1.19-1.08-2.062zm11.883.293-2.092.986q-.21-1.275-.56-2.017l-1.112-2.353-4.023 1.897.568 1.203q.743 1.571 1.752 2.861l-2.092.986q-.203-1.26-.98-2.906l-1.753-3.71q-.796-1.685-1.713-2.797l2.091-.987q.28 1.438.753 2.441l.821 1.739 4.023-1.897-.577-1.224q-.667-1.41-1.645-2.65l2.092-.986q.244 1.364.955 2.869l1.652 3.496q.903 1.912 1.84 3.048zm3.367-14.293.47 1.69q-.857.125-1.393.343-.424.173-1.25.69l3.117 4.897q1.22 1.915 2.166 2.741l-1.951 1.241q-.278-1.111-1.593-3.176l-3.086-4.846q-.914.669-1.336 1.024-.695.6-1.157 1.21l-.428-1.718z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    transform: "matrix(1.60215 -.01667 .01796 1.62571 271.006 -711.78)",
    strokeWidth: 0.946
  })), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(763.551 -306.847) scale(1.3183)",
    d: "M28.807 554.373c-.87-.89-2.09-2.318-3.085-3.61-2.678-3.48-4.66-7.182-5.624-10.508-.339-1.17-.447-1.837-.485-2.988-.032-.984-.03-1.006.118-1.748.462-2.306 1.148-3.772 2.307-4.927.959-.955 1.959-1.522 3.716-2.108 1.747-.583 3.259-.816 4.977-.766 2.703.077 5.025.842 8.62 2.84.874.486 2.547 1.491 2.763 1.66.086.068.09.11.051.535-.14 1.53-.163 2.76-.166 8.813-.003 4.534-.022 6.546-.067 7.284-.035.56-.073 1.051-.086 1.09-.015.047-.176-.08-.494-.393-.745-.73-1.329-1.162-2.074-1.534-1.54-.77-3.124-.781-5.078-.036-2.047.782-3.675 2.469-4.484 4.648-.194.524-.39 1.286-.443 1.72-.019.156-.049.31-.066.344-.022.04-.159-.07-.4-.316z",
    fill: "#faecbd",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(763.551 -306.847) scale(1.3183)",
    d: "M41.169 549.338c-.998-.938-2.198-1.618-3.21-1.82-.38-.076-.396-.087-.394-.293 0-.118-.204-4.195-.453-9.06-.25-4.866-.437-8.864-.416-8.885.094-.094 3.657 1.827 4.997 2.693.53.343.503.254.397 1.304-.038.377-.097 4.163-.131 8.412-.034 4.249-.083 7.826-.108 7.949-.025.122-.065.221-.09.22-.023-.003-.29-.236-.592-.52z",
    fill: "#ae4c33",
    strokeWidth: 0.008,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(763.551 -306.847) scale(1.3183)",
    d: "M33.96 547.97c0-.033-.615-4.58-1.365-10.106-.751-5.525-1.346-10.065-1.323-10.088.087-.087 1.788.19 2.59.422.454.13 1.274.413 1.821.627l.996.39v.63c0 .654.728 15.673.819 16.902l.052.698-.334-.055c-.464-.075-1.76.13-2.574.406-.375.128-.682.206-.682.173z",
    fill: "#dba35a",
    strokeWidth: 0.012,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(763.551 -306.847) scale(1.3183)",
    d: "M28.07 553.502c-3.143-3.534-5.418-6.98-6.919-10.48-1.407-3.282-1.792-5.812-1.234-8.113.872-3.598 2.47-5.315 5.99-6.436 1.454-.464 2.777-.699 4.063-.722.633-.012 1.17 0 1.195.027.024.027.511 3.545 1.082 7.818a6617.7 6617.7 0 0 0 1.354 10.1l.317 2.33-.588.316c-2.014 1.08-3.457 3.067-3.988 5.487-.09.414-.198.753-.238.753-.04 0-.506-.486-1.034-1.08z",
    fill: "#e9be79",
    strokeWidth: 0.012,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1206.695 243.13a56.554 56.554 0 0 1-6.564-5.47c-.655-.637-1.15-1.183-1.102-1.213.048-.03.18-.441.291-.914.65-2.735 2.409-4.841 4.793-5.739 2.632-.99 4.7-.564 6.79 1.403l.776.728-.108 1.069c-.402 3.992-1.44 7.339-3.136 10.124-.269.44-.523.801-.564.801-.04 0-.57-.355-1.176-.79zm-16.392 17.742c-.353-.425-2.257-4.412-2.57-5.383-.36-1.11-.944-3.38-1.078-4.188l-.073-.436.947.906c2.296 2.194 5.364 4.777 7.5 6.314.492.355.896.68.898.723 0 .059-.65 1.09-.833 1.317-.016.02-.982.204-2.146.41-1.164.205-2.21.396-2.324.424-.117.029-.257-.01-.322-.087z",
    color: "#000",
    fill: "#012169",
    stroke: "#500",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(-778.638 112.725) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1.3183 0 0 1.3183 1392.538 -334.29)",
    d: "m288.545 612.172-3.756-11.071 6.73 3.777.893 2.06-.206 1.923-.412 1.304-.962 1.03z",
    fill: "#f9e7d9",
    stroke: "#500",
    strokeLinejoin: "round",
    strokeWidth: 0.12,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.738 673.714c-.682 1.023-.14 1.461 0 2.091 0 0 4.514 4.678 6.098 7.44 1.28 2.232 2.65 7.2 2.65 7.2-.388-1.787 3.058-4.638 5.551-4.826 1.938-.147 4.506 1.232 4.879 3.057.34 1.664-.852 3.765-3.028 4.183 5.883-1.273 2.944-6.706 1.85-9.211 0 0-1.71-2.848-2.271-4.389-1.103-3.028-2.103-9.406-2.103-9.406-7.117-2.584-10.923-.19-13.626 3.86z",
    fill: "#e6ba74",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(-1.5221 0 0 1.5916 1908.497 -630.008)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1.3183 0 0 1.3183 1036.472 -305.802)",
    d: "M8.877 561.5c-3.06.123-5.352 1.456-7.203 3.48 3.15 5.446 8.078 13.62 8.078 13.62l-5.77-13.598c2.207-2.44 4.999-2.832 8.24-1.648l-.19-1.577c-1.133-.218-2.187-.316-3.155-.277z",
    fill: "#f9e7d9",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1.3183 0 0 1.3183 1036.472 -305.802)",
    d: "M12.578 561.88c.85 5.9 2.205 15.955 2.766 20.13.331-.095.66-.163.972-.188 2.238-.177 5.202 1.487 5.631 3.69.354 1.813-.734 4.051-2.797 4.842 5.814-1.832 2.654-8.003 1.438-10.913 0 0-1.973-3.437-2.621-5.298-1.273-3.656-2.428-11.356-2.428-11.356a22.192 22.192 0 0 0-2.96-.906zm6.572 28.474c-.228.071-.443.15-.699.208.245-.049.477-.123.7-.208z",
    fill: "#c47645",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1.3183 0 0 1.3183 1036.472 -305.802)",
    d: "m13.283 562.068 4.307 19.85c1.959.367 4.006 1.79 4.357 3.594.354 1.813-.734 4.051-2.797 4.842 5.814-1.832 2.654-8.003 1.438-10.913 0 0-1.973-3.437-2.621-5.298-1.273-3.656-2.428-11.356-2.428-11.356-.79-.3-1.534-.527-2.256-.719z",
    fill: "#ab1e2b",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.738 673.714c-.682 1.023-.14 1.461 0 2.091 0 0 4.514 4.678 6.098 7.44 1.28 2.232 2.65 7.2 2.65 7.2-.388-1.787 3.058-4.638 5.551-4.826 1.938-.147 4.506 1.232 4.879 3.057.34 1.664-.852 3.765-3.028 4.183 5.883-1.273 2.944-6.706 1.85-9.211 0 0-1.71-2.848-2.271-4.389-1.103-3.028-2.103-9.406-2.103-9.406-7.117-2.584-10.923-.19-13.626 3.86z",
    fill: "none",
    stroke: "#520",
    strokeLinejoin: "round",
    strokeWidth: 0.102,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(-1.5221 0 0 1.5916 1908.497 -630.008)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1356.256 261.709c.318-.41 2.036-4.266 2.32-5.205.323-1.072 1.09-3.17 1.212-3.952l.066-.422-.855.876c-2.07 2.122-5.03 4.764-6.957 6.25-.444.342-.809.656-.81.698 0 .057.537.813.703 1.033.015.019.885.197 1.935.396 1.05.198 1.994.383 2.097.41.105.027.232-.01.29-.084z",
    color: "#000",
    fill: "#012169",
    stroke: "#500",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(-778.638 112.725) scale(1.3183)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M899.032 441.717s-127.428-32.369-126.685-155.514l.982-162.78h251.408l.985 161.845c.743 123.145-126.69 156.45-126.69 156.45z",
    fill: "#2a7fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M346.306 143.025c-.84-.255-1.255-.634-1.255-1.148 0-.255-.13-.401-.32-.362-.175.036-.464-.134-.642-.378-.3-.411-.222-.557 1.11-2.058l1.433-1.617.642-2.731c.672-2.864 1.64-8.743 1.887-11.453.156-1.725.313 1.753-.11 1.6-1.475-.206-2.125-2.787-4.372-2.909-2.35-.126-3.337-4.34-3.978-4.533-1.696-.511-4.783-1.209-7.698-4.144-2.651-2.67-2.84-2.943-4.259-6.168-.358-.814-1.143-2.218-1.745-3.12l-1.095-1.638-.245-3.454c-.135-1.9-.403-4.2-.596-5.113-.376-1.776-.34-2.273.385-5.36.387-1.646.426-2.327.3-5.221l-.143-3.328-1.11-1.184c-1.443-1.54-1.94-2.722-2.161-5.149-.293-3.207-1.523-6.099-3.87-6.74-.615-.168-2.224-.197-5.025-.089-5.707.22-7.016.924-7.324-1.102-.072-.478-.331-1.083-.576-1.346-.328-.352-.515-1.04-.712-2.612l-.267-2.134.699-.959c1.977-2.713 9.076-9.929 14.755-14.998.705-.63.937-1.016 1.03-1.721.138-1.033.587-1.47 1.704-1.66 1.526-.26 1.662-.326 2.033-.991.41-.737.76-.813 1.867-.409.641.234.788.212 1.23-.19.452-.41.76-.45 3.15-.413 2.286.035 2.76.107 3.444.525.437.266 1.521.733 2.411 1.039.89.305 1.783.706 1.985.89.201.184.958.577 1.68.873 1.762.723 4.722 2.471 6.531 3.86a26.564 26.564 0 0 0 3.077 1.98c2.787 1.479 8.924 6.31 9.364 7.374.223.537.577.855 1.303 1.168.548.238 1.422.826 1.941 1.307l.946.876 3.533.36c6.327.645 9.605.805 16.57.81 7.79.006 10.17-.158 17.767-1.225 8.855-1.243 12.492-1.524 17.665-1.368 4.907.149 5.958.295 7.954 1.109 2.808 1.144 7.646 4.417 10.18 6.887 2.077 2.022 4.763 7.692 6.279 13.25.89 3.263 1.136 5.618.785 7.506-.417 2.245-1.11 2.56-1.975.896-.938-1.803-1.4-2.585-1.48-2.505-.048.048.024.766.16 1.595.186 1.127.184 1.789-.007 2.625-.439 1.916-.332 2.522.852 4.829l1.109 2.159-.22 2.228c-.12 1.225-.222 2.79-.225 3.479l-.006 1.25-1.013.391c-1.011.39-1.013.393-.83 1.2.665 2.914-.341 5.88-2.482 7.313-.657.44-1.205.912-1.217 1.048-.117 1.358.697 6.925 1.34 9.159.501 1.743.559 3.357.217 6.108-.235 1.892-.536 2.676-1.918 4.994l-.773 1.297.502 1.6c.275.879.51 1.947.522 2.372.02.75-.013.782-1.083 1.037-1.6.382-3.238.367-3.806-.035-.268-.189-.707-.287-.988-.22-.278.066-.65.025-.825-.09-.27-.177-.195-.52.475-2.175.803-1.981 1.789-5.406 2.054-7.133.08-.519-.017-2.105-.217-3.565-.444-3.23-1.188-4.919-3.359-7.623-1.177-1.466-1.832-2.06-3.014-2.73-.83-.47-1.587-.855-1.681-.855-.095 0-.44.743-.769 1.65-.635 1.757-.964 2.185-1.976 2.573-.634.244-.635.248-.53 1.854.057.886.382 2.468.722 3.516l.618 1.905-.943 2.105c-.518 1.158-1.116 2.609-1.327 3.224-.468 1.362-1.303 3.038-2.097 4.211l-.592.873.495 1.578c.272.867.504 1.926.515 2.351.021.75-.013.782-1.082 1.037-1.84.438-3.276.376-3.967-.173-.458-.363-.645-.411-.775-.199-.185.302-1.11.122-1.11-.216 0-.107.331-1.028.736-2.046.896-2.25 1.454-4.346 2.36-8.851l.69-3.437-.484-1.354c-.832-2.327-3.28-6.978-3.993-7.583-.371-.315-.945-.567-1.293-.567-.473 0-.874-.28-1.647-1.147l-1.022-1.147-1.928.924c-1.254.601-2.235.925-2.807.926-.484 0-1.556.066-2.382.145-1.35.128-1.534.205-1.816.757-.744 1.451-1.36 1.632-2.623.768l-.813-.557-.64.478c-.56.417-.818.459-2.068.33-1.228-.128-1.542-.081-2.233.33-.67.399-.977.45-1.841.304a12.819 12.819 0 0 0-2.152-.132 4.874 4.874 0 0 1-2.102-.4c-.787-.35-1.167-.4-1.867-.243-1.474.332-6.472.123-7.814-.326-.99-.332-1.307-.352-1.986-.126-1.23.41-2.025.232-2.451-.55-.82-1.505-1.94-.42-1.796 1.741.098 1.457-.337 1.936-1.759 1.936-.933 0-1.101.075-1.437.65-.21.356-.61.754-.89.883-.485.223-.503.315-.383 1.968a11.44 11.44 0 0 1-.238 3.406c-.627 2.887-.785 4.045-.928 6.806l-.14 2.685.915 2.05c.503 1.128.915 2.146.915 2.262 0 .116-.342.474-.76.796-1.051.809-2.979 1.228-4.698 1.023-1.216-.146-1.48-.271-2.305-1.096l-.932-.931 1.143-1.653c1.567-2.264 1.812-3.34 1.805-7.923-.007-4.665-.323-8.936-.679-9.158-.295-.184-1.201 1.534-1.325 1.658-.042.043-1.708.074-1.969 2.573-.528 5.069-.932 6.935-2.086 9.646l-.788 1.85.673 1.861c.764 2.113.724 2.267-.776 2.955-.949.436-3.652.542-4.817.189z",
    color: "#000",
    fill: "#333",
    stroke: "#333",
    strokeWidth: 2.987,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.58 60.895c.08.267.374 1.413.374 1.76s-.24 1.494-.24 1.84c0 .347-.48 2.267-.48 2.267l1.28.214.533-1.254s.214-1.147.214-1.307.186-2.293.186-2.293l-.08-1.387z",
    fill: "#c27e50",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(535.4 -59.232) scale(4.82918)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(535.4 -59.232) scale(1.27772)",
    d: "m261.066 231.666-4.736.102c.302.604.1 1.41 1.008 2.52.907 1.108 1.813 2.217 2.217 2.62.403.403.605 1.109.605 2.319s.1 2.117.1 3.628-.906 4.536-1.108 5.342c-.201.807-1.613 4.535-1.613 4.535s1.086-.452 1.662-.183l1.766-4.15s.806-4.335.806-4.94c0-.605.706-8.668.706-8.668l-.137-2.365z",
    fill: "#ab612e",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.248 66.78-.83.905c.03.09.15.267.204.347.018.028.43-.507.451-.48.033.04-.402.55-.362.586.282.255.736.396 1.348.32.49-.092.68-.179.849-.472l-.387-1.018z",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(535.4 -59.232) scale(4.82918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.534 67.085c-.033.06-.66.963-.641.982.46.495 1.72.42 1.748.015-.66.096-1.087.249-1.494-.257z",
    fill: "#a1a1a1",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(535.4 -59.232) scale(4.82918)"
  })), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.079 116.133c.968.484 2.744 4.035 2.744 4.035s.968 1.776 1.775 1.937c.807.161 0-.807 1.775.484 1.776 1.291 4.035 2.26 4.035 2.26l3.228-.162s3.228-.645 3.874-.968c.646-.323.968.161 1.453-1.614.484-1.775 1.13-2.098 1.29-4.52s.162-6.617.162-6.617l-.645-2.743h-4.358l-5.81.322-4.197-.322-1.937 2.743z",
    fill: "#acacac",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e2c773",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.25,
    style: {
      paintOrder: "markers stroke fill"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-239.03-7.707s-2.617-3.864-3.116-4.611-2.368-3.988-4.237-7.104-1.856-4.35-3.49-5.982c-1.87-1.868-4.332-3.195-6.854-3.988-3.857-1.213-8.049-1.164-12.088-.997-2.273.094-4.564.43-6.73 1.122-3.433 1.097-8.848 4.112-9.72 4.735-.873.623-5.858 5.608-5.858 5.608s-2.617 2.493-3.365 3.365c-.748.873-3.988 3.864-5.11 4.736-1.121.872-4.486 5.359-5.234 5.982-.748.623-1.122 1.122-2.119 2.119-.997.997-1.62 2.243-1.994 2.741-.373.499-1.246 1.994-1.246 1.994s0 2.119.374 3.24c.255 1.207-.1 4.062.872 5.733.506.87 2.368 1.87 2.368 1.87 6.07.156 11.904.904 11.466-2.991-1.199 2.894-6.748 5.783-11.466 2.98l-.498 2.13c.19.954.153 1.978 1.37 2.616 3.344 1.644 6.03 1.808 8.724 1.994l7.727-1.121c2.584-.292 9.887-.332 13.36 3.525 2.459 2.763 7.303 12 6.28 15.396l33.106-.882-.168-25.352-.672-13.432z",
    fill: "#d7b5a0",
    stroke: "#7d5035",
    strokeWidth: 0.666,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(1000.821 159.586) scale(.63366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-284.628-24.538c-.908.887-1.166 1.3-2.796 2.538-1.63 1.238-3.077 2.681-5.986 5.88-2.909 3.198-5.741 4.463-3.278 5.676 2.464 1.213 1.545 2.036 2.18 2.977.636.94.33 2.848 1.482 5.77 1.152 2.921 6.837 3.358 6.837 3.358s4.478.949 4.783-.628c.305-1.576-1.383-4.683 1.638-5.08 3.02-.396 4.073 1.77 6.075-.54 2-2.312 1.155-6.81 3.507-8.399 2.352-1.588 2.975-2.694 2.975-2.694s-4.717 1.13-6.26 1.077c-1.544-.054-6.12-1.758-6.57-3.235-.45-1.477-1.38-7.751-1.38-7.751z",
    fill: "#d0a386",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(1000.821 159.586) scale(.63366)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-309.942 4.88 1.62-2.119c1.158-.013 1.661.433 1.995.997.61.3 1.216.553 1.744-.124l-.124-1.994c.86.602 1.622 1.227 1.744 1.994-.357.974-.803 1.92-3.115 2.243-1.164.3-2.481 1.498-3.396 2.96-.174-1.569-.128-2.97-.468-3.957z",
    fill: "#000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(1000.821 159.586) scale(.63366)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-296.945-12.308c1.987 1.496 3.176 1.205 3.372 4.22.196 3.013-.608 2.67-.06 3.436.547.767 2.914 2.35 3.37 4.219.457 1.87.537 2.93.276 4.075-.261 1.144-.563 2.118-.397 2.798.166.68.917 3.018.917 3.018s-1.949-.605-2.575-2.433c-.627-1.828-.667-.729-3.333-2.059-12.911 18.022-5.832-5.968-6.42-6.904-.59-.937-3.637-2.354-3.637-2.354 2.853-2.81 5.96-7.055 8.487-8.016z",
    fill: "#dec7b7",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(1000.821 159.586) scale(.63366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-263.156-6.644c-.61 1.016-1.423 3.049-3.252 4.065-1.83 1.016-5.691 1.83-7.317 1.83-1.626 0-3.05-1.83-4.065.202-1.017 2.033-1.626 2.846-2.236 4.675-.61 1.83-3.862 1.83-4.065 3.049-.203 1.22-1.22 1.83-1.423 4.268-.203 2.44-.61 4.472-.61 4.472s1.626-4.065 3.659-4.269c2.032-.203 2.236 0 4.878-.203s4.675-.406 6.097-2.236c1.423-1.829 4.269-3.455 6.504-3.658 2.236-.203 4.269-.61 5.285-3.252s1.83-2.642 1.016-4.675c-.813-2.032-4.471-4.268-4.471-4.268zm-12.872-15.148c2.587 0 2.443-.287 3.737 0 1.293.288 2.155 1.006 2.874 2.012.719 1.006.287 1.869 2.012 2.012 1.725.144 2.874.863 2.874.863s.575 1.437 1.15 1.293c.575-.144.719-2.874.719-4.168 0-1.293-1.294-3.736-1.294-3.736l-2.587-1.438s-.939-.381-2.664-.813c-1.724-.43-1.935.382-2.797.382-.862 0-1.293-.43-2.3.719a45.188 45.188 0 0 0-1.868 2.3z",
    fill: "#d0a386",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(1000.821 159.586) scale(.63366)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M318.786 50.49s.553-.801.898-1.14c.258-.254.515-.562.864-.657.57-.155 1.222-.035 1.761.207.395.178.691.277.968.864.276.587.069.553.449.794.38.242.483.346.483.346s-.242.138-.76.414c-.518.277-.875.512-1.347.691-.344.131-.703.31-1.07.276-.467-.041-.849-.4-1.278-.587-.195-.084-.588-.242-.588-.242s-.276.07-.449.38c-.172.311-.345.415-.518.83-.173.414-.483 1.036-.483 1.036l-.208.31s-.138-.518-.138-.794.035-.622.104-1.036c.069-.415.552-1.106.552-1.106z",
    fill: "#662900",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)"
  })), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.194 62.095c0 .427.133 1.28.16 1.867.027.587.027.933.027 1.307v.873l-.127.68 1.274-.006s-.103-.271-.065-.618c.063-.564.145-1.33.145-1.463 0-.213-.08-1.706-.08-1.706l-.24-.854z",
    fill: "#c27e50",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(535.4 -59.232) scale(4.82918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3 62.789s-.026.8.08 1.066c.107.267.72.134.854.56s.267.907.267.907l.074-.507.166-.52.16-.866-.44-2.534s-1.534 0-1.534.16.374 1.734.374 1.734z",
    fill: "#ab612e",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(535.4 -59.232) scale(4.82918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.245 66.792-.721.994c.039.087.18.248.241.322.022.025.37-.553.394-.53.038.037-.337.594-.293.625.31.221.777.31 1.376.164.475-.147.655-.255.79-.565l-.5-.967z",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(535.4 -59.232) scale(4.82918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.564 67.064c-.026.063-.546 1.03-.526 1.048.514.439 1.757.221 1.739-.184-.644.17-1.051.37-1.513-.085z",
    fill: "#a1a1a1",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(535.4 -59.232) scale(4.82918)"
  })), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.447 58.972c.188 1.018.49 2.112.83 2.678.34.566.943 1.999.943 1.999s-.302 1.094-.302 1.358-.34 1.565-.34 1.565l1.245-.132s.604-.868.717-1.396.603-1.244.603-1.47-.34-1.019-.34-1.019-.075-1.546-.075-1.81.038-1.886.038-1.886z",
    fill: "#c27e50",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(535.4 -59.232) scale(4.82918)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(535.4 -59.232) scale(1.27772)",
    d: "m331.715 222.459-9.543.326c.99 2.245 1.834 3.934 3.27 6.088 1.71 2.566.713 1.712 2.423 5.133 1.71 3.421 1.141 3.848 2.424 5.416 1.283 1.568 1.566 2.851 1.566 2.851s.6-.688 1.227-1.707c.028-.104.057-.212.057-.289 0-.855-1.284-3.847-1.284-3.847s-.283-5.846-.283-6.844c0-.998.143-7.127.143-7.127z",
    fill: "#ab612e",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.777 66.804-.221.918c.35.342 1.01.144 1.653-.026l-.373-1.254-1.28.107-.48 1.12c.258.108.468.172.428.007z",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(535.4 -59.232) scale(4.82918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.756 66.709c.027.067.307.88.307.88-.456.17-.896.264-1.28.08l1.04-.213z",
    fill: "#8a8a8a",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(535.4 -59.232) scale(4.82918)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M405.079 110.133c.968.484 2.744 4.035 2.744 4.035s.968 1.776 1.775 1.937c.807.161 0-.807 1.775.484 1.776 1.291 4.035 2.26 4.035 2.26l3.228-.162s3.228-.645 3.874-.968c.646-.323.968.161 1.453-1.614.484-1.775 1.13-2.098 1.29-4.52.162-2.42.162-6.617.162-6.617l-.645-2.743h-4.358l-5.81.322-4.197-.322-1.937 2.743z",
    color: "#000",
    fill: "#acacac",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.996 59.899c.267.773 1.1 1.575 1.26 1.868.16.294.029.143.527.808.027.854.293 1.574.187 1.947-.107.373-.347 1.44-.347 1.44l1.173-.106s.267-.48.427-.72c.16-.24.4-.827.4-.827s-.027-1.094-.027-1.227-.32-1.654-.32-1.654l-.72-1.066-.586-.614z",
    fill: "#c27e50",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(535.4 -59.232) scale(4.82918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.37 59.562c.24.506.943 1.49 1.397 1.65.453.16.47.456.47.456s.133.24.106.72c-.027.48-.267.694.107 1.12.373.427.773.534.773.534l.376.203.09-1.41-.28-.873-.133-.827-.154-1.24-1.179-.707z",
    fill: "#ab612e",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(535.4 -59.232) scale(4.82918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.83 66.136-.22.92c.35.341 1.01.143 1.653-.027l-.373-1.254-1.28.107-.48 1.12c.258.108.468.172.428.006z",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(535.4 -59.232) scale(4.82918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.81 66.042c.026.066.306.88.306.88-.455.17-.895.264-1.28.08l1.04-.213z",
    fill: "#8a8a8a",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(535.4 -59.232) scale(4.82918)"
  })), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.442 46.082c.905-1.477 1.605-1.584 2.43-2.352.536-.499 1.637-1.463 1.637-1.463s-.092-1.517.381-2.007c.772-.8 3.251-.737 3.251-.737s.017-1.204.461-1.442c.771-.414 2.525.715 2.525.715s.447-1.098.946-1.28c.863-.317 2.686.635 2.686.635s1.244-.698 1.914-.635c.928.087 1.394 1.038 2.444 1.361 1.049.323 2.048.42 2.963.899.495.258 1.314 1.038 1.314 1.038s1.526.403 2.237.737c.726.342 2.04 1.28 2.04 1.28s.93.384 1.35.657c1.01.657 2.766 2.33 2.766 2.33s1.728.77 2.56 1.22c.81.44 2.363 1.443 2.363 1.443s1.663 1.34 2.479 2.028c.716.604 2.12 1.845 2.12 1.845s1.383.56 1.832 1.116c.357.443.246 1.412.56 1.612.314.2 1.488.399 2.122.814.653.427 1.644 1.668 1.644 1.668 10.566 1.392 21.466 1.778 32.813.828 0 0 12.966-2.21 19.516-2.283 4.05-.045 8.295-.254 12.098 1.142 4.18 1.534 10.956 7.646 10.956 7.646l3.424 6.163 2.283 7.076c1.908 6.452-.454 11.789-1.598 7.076-.61.63-2.49-6.138-2.397-6.277l-.685-3.766 1.256 7.133.913 4.052-.57 2.396-.572-1.483.571 3.195 2.169 3.767v1.712l-.343.456-.114 5.136-2.168.685c.615 1.675 1.044 3.305.456 4.68l-1.37 2.738-2.624 1.598c-.01 1.169.45 2.396-.685 3.424-.942.224-1.747 1.195-2.968-.114 0 0-1.088 1.23-1.826 1.255-.75.027-1.94-1.141-1.94-1.141l-2.168.342-2.854-1.483-2.282 1.027h-1.484l-3.538-2.511s-3.082-.685-3.424 0c-.342.685-1.826 1.027-1.826 1.027l-2.853-.913-2.74.8-1.255.912-2.282 1.598-2.055-.228s-2.51-.343-2.739.342c-.228.685-.586 2.15-1.484 2.283-.934.138-2.168-1.826-2.168-1.826s-.59 1.148-1.141 1.37c-.925.369-2.968-.343-2.968-.343s-1.096 1.14-1.826 1.255c-.785.123-2.282-.685-2.282-.685s-1.128.542-1.712.457c-.795-.115-2.055-1.255-2.055-1.255s-1.49.621-2.282.684c-1.148.092-3.424-.456-3.424-.456s-1.018.475-1.557.442c-1.06-.064-1.935-1.082-2.938-1.236-.648-.099-1.116.95-1.43.95-.799 0-1.481-.437-1.481-.437l-.466-1.116-.852-.267-.52.294c.769 1.003-.289.676-.571.913l.456 1.712c-.169.636.321 1.327-1.484 1.826 0 0-1.483-.57-1.597 0-.115.57-.685 1.256-.685 1.256s-1.986.029-1.826.456c.327.875.716 1.75 0 2.625 0 0-1.565.574-2.343.419-.697-.14-1.795-1.153-1.795-1.153l-.77-2.119s-2.355-.087-3.31-.685c-1.057-.662-2.282-2.967-2.282-2.967H349.6s-3.081-.114-3.538-.114-5.834.18-8.445-.913c-1.995-.836-5.022-4.11-5.022-4.11s-2.4-2.243-3.196-3.651c-.491-.87-.913-2.853-.913-2.853l-1.37-2.169s-1.415-1.704-1.711-2.74c-.137-.474 0-1.483 0-1.483l-.343-5.25s-.79-2.02-.799-3.081c-.01-1.449 1.028-4.223 1.028-4.223l.342-2.853-.457-2.854s.24-1.413 0-2.054c-.406-1.086-1.676-1.637-2.282-2.625-.45-.735-.82-1.548-.97-2.397-.14-.79.213-1.613.08-2.404-.184-1.089-1.189-3.092-1.189-3.092l.48-1.01s3.31-3.309 4.338-3.309c1.027 0 3.137.533 4.388-.228 1.544-.94 2.85-2.875 2.74-4.68-.112-1.815-2.627-2.651-3.31-4.336-.778-1.918-.737-6.163-.737-6.163l-1.027-2.511-1.483-1.712-4.223-.8z",
    fill: "#c9c9c9",
    stroke: "#b3b3b3",
    strokeLinejoin: "round",
    strokeWidth: 0.12,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.131 92.453c2.736.39 3.713.586 5.96-.098 2.247-.684 4.396-1.66 4.396-1.66s-1.27 1.953-2.345 2.54c-1.074.585-2.833 1.66-2.735 2.05.097.392.195.099 1.758-.488 1.563-.586 4.592-2.149 2.247.587-2.344 2.735-3.42 3.126-3.614 3.712-.196.586-1.27 2.052-1.173 2.93.098.88 3.81-.488 3.81-.488s-1.563 1.173-3.126 2.736c-1.563 1.563-2.345 2.247-2.345 2.247s-1.758-.977-1.856-4.494c-.098-3.517-1.172-7.327-1.368-8.109-.195-.781 0-1.758 0-1.758z",
    fill: "#acacac",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.452 104.636c-.294.078-.066-.463-1.207-.463-1.005 0-1.663-.076-2.28-.214l.15.2 1.372 2.168s.422 1.984.913 2.853c.796 1.408 3.196 3.652 3.196 3.652s3.026 3.273 5.021 4.109c2.612 1.094 7.99.913 8.446.913.411 0 2.693.085 3.19.103-.175-.375-.367-.82-.606-1.458-1.37-3.653-1.826-2.511-2.74-3.424-.912-.913-.913-.457-2.51-2.74-1.598-2.282-4.794-1.14-4.794-1.14s-2.51-.229-4.108-1.598c-1.598-1.37-.593-.37-1.962-1.967-.514-.6-2.001 2.164-2.08-.994z",
    fill: "#959595",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M836.264 134.295s-1.433 2.345-1.954 2.997c-.522.652-2.608.784-3.13.784l-2.997 1.694 4.562.13 3.78 3.519 3.26 6.126-1.435-6.256 5.475 1.435s.131 3.518-.13 4.17c-.26.652-2.086 4.042-2.607 5.346-.522 1.303 4.562 5.083 4.562 5.083v-4.04l6.388-4.043 4.824-3.649 3.519 2.738s3.519 5.475 3.519 6.127c0 .19-.32.839-.75 1.63-3.236 2.792-5.698 6.56-7.785 10.298-1.477 5.585-10.634 1.604-4.485-2.303 1.493-2.004 3.807-4.698 5.74-7.16-3.411 1.54-8.617.93-11.73 2.902-4.233 3.504-11.596 8.968-14.967 10.085 1.461.078 2.984-.198 4.402.237 6.773-1.167 2.4 4.927-2.002 3.995-6.46-.198 1.094 2.89 3.811 2.052 3.734-.43 11.923-.052 6.014 4.355 6.877 3.124 12.64-2.238 18.128-5.398 1.818 1.79-5.618 6.888-7.756 9.108-3.534 4.677-8.504 4.302-13.431 4.205-2.548 2.142 3.28 1.356 4.756 1.478.217 3.918-14.752 2.284-8.664 8.245 6.083.483 12.413.952 18.317-.97 4.663-1.639.622 2.113-.609 3.468 1.981 3.07 8.161-2.203 11.682-2.49 2.381 5.2-7.209 5.635-10.344 8.604 3.164.437 13.713.443 17.386-5.076 4.425-3.838 6.04 2.353 2.43 4.787-4.413 3.545-10.154 7.35-15.559 7.666-7.07-4.732-6.015 3.748-11.089 6.808 8.194 1.366.642 3.259 4.064 4.604 6.58 1.55 10.432-6.348 16.438-2.158 5.33 4.252 1.247-9.583 5.595-6.783-1.697-6.376 6.6-4.366 6.878.481.678 4.4 3.59 3.238 2.887-.681.325-3.332-.122-6.476-2.595-8.981-1.968-5.89 8.102-3.73 6.451 1.794 2.297 8.673.661-9.632 4.153-5.977 3.513 4.356 1.39 12.648 6.565 15.3 4.076-1.824 8.396 5.001 10.726 2.336 4.403-4.841.533-12.37 1.073-18.3 3.192-3.209 4.394 3.544 3.3 6.172.204 4.576-.43 9.278.361 13.768 1.895-.907 3.573-6.806 4.148-9.913.323-4.094-2.308-11.296 4.504-10.137-.357 4.797 1.6 7.637 5.261 10.21 4.55 5.189-1.61-8.225 4.13-4.712 1.278 1.563 5.182 13.223 4.884 7.377 1.366-5.994-1.025-11.468-1.158-17.347 2.961-1.336 5.941 5.987 6.439 9.276 2.072-.073-3.303-10.276-1.737-10.082 5.67 2.525 8.607 8.205 10.429 13.895 2.633 6.938-.393-3.767-.826-6.26 2.992 5.338 6.032 10.713 8.262 16.495.258-3.909-.41-7.731-1.405-11.5-1.59-8.34 4.15-.397 5.822 2.88 3.964 4.206 5.411 9.656 7.672 14.804.826 4.354 1.643.2 3.192-1.243 4.589-5.252-1.157-11.505-1.168-17.464 1.47-6.081 3.213 4.112 3.673 6.13 2.216.551 3.852 11.384 4.018 6.95.095-1.272.143-1.814.187-2.297.142-2.726.238-5.455.17-8.195 8.826 7.79 5.35-12.778-1.253-24.17-2.169-5.249 2.313.061 2.543 2.593 5.081 1.483-1.367-9.947 3.287-7.96 2.21 6.906.573-3.623.013-5.785-4.5-4.54-8.7-11.683-15.857-12.478.349.332.644.674.943 1.01.06.237.544.777 1.15 1.403-.022-.03-.107-.157-.136-.197.062.083.168.213.21.27 1.942 1.996 5.669 5.369 6.62 7.579 1.968 7.35-6.29-1.816-7.963-1.118 2.99 5.894-2.363 1.946-4.582.087-3.56-4.008-5.279-10.425-11.148-11.694-2.127 1.91 5.375 5.95 6.915 8.72 1.733 1.468 6.489 10.13 3.504 8.906-.775-.468-1.145-.73-1.505-.983-3.393-1.735-8.958-5.159-11.075-9.002-4.544-5.36-1.921 1.502 1.29 3.267.294 2.653 5.013 12.942-.374 10.21-5.657-4.298-7.21-11.33-11.405-16.656-1.431.981 1.873 8.601 1.25 12.288 1.124 6.809-2.884 1.64-4.494-1.522-4.006-1.886-2.09-10.698-5.26-10.604-1.551 4.72-1.689.911-3.003-1.57-1.852 3.883-.828 8.221-1.185 12.341.433 7.564-3.58-1.12-4.52-4.073.493-4.57-1.756-4.21-2.453-.122-.415 8.6-5.6-.693-5.34-4.31 2.268-5.032-6.856-8.432-6.406-2.727 2.132 4.817 3.573 12.313.372 17.349.871-6.59-6.262-10.95-5.171-17.801-1.588-5.252-3.394-.483-3.843 2.483.391 5.811-1.59 9.486-5.186 13.723-3.328 5.438-2.562-1.647-3.352-4.193-2.06-9.028-.867 4.11-2.917 6.636-2.67-3.211-2.851-10.525-2.708-15.442 1.897-5.99-2.063.775-2.428 1.54-.12.195-.182.27-.312.486-3.43 7.654-2.946-1.994-3.384-5.543-.157-4.491-.755-.766-.98 1.213-.022.166-.033.205-.055.39-.705 2.33-.426 14.092-3.601 7.965-1.516-1.556-1.215-11.893-2.012-6.927-.126 7.853-5.116-2.242-3.102-5.708.106-6.093-.141 1.31-1.138 3.112-2.77-3.663-1.913-7.666-.75-11.784-.856.302-1.669.673-2.444 1.093-.047-.5-.105-1.053-.165-1.35-.13-.651-.391-1.172-.521-2.997s.391-2.086.391-2.086-2.345-.262-2.867-.784c-.521-.521-1.305 0-4.043-.651-2.737-.652-6.517-3.911-7.95-5.475-1.434-1.565-1.305-1.955-2.087-2.868-.782-.912-1.435 2.087-1.435 2.087s-2.866-.131-4.17-3.26c-1.303-3.128-1.302-1.435-1.302-1.435s-3 2.87-4.695.784c-1.694-2.086-1.435-3.389-1.435-3.389zm126.265 45.312a31.8 31.8 0 0 0 2.016.963c-1.92-1.42-3.526-2.029-2.016-.963zm8.157-11.497c-.02-.022-.051-.051-.072-.073.197.263.217.273.072.073zm8.932 53.51c-.064 1.233-.119 2.466-.207 3.7.216-2.34.386-5.644.207-3.7zm-122.998-62.7c1.872-.845 3.212-2.328 3.351-5.26-.277 1.156-1.672 3.122-3.351 5.26z",
    fill: "#e5e5e5"
  })), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.804 56.28c-.306-1.36-.68-2.7.082-4.381.428-1.399 2.428-2.55 4.05-2.811 2.5-.401 6.378.084 7.283 2.16.605 1.387.934 3.225-1.82 4.107-2.049.753-4.02 3.257-6.289 3.57-.939-.902-1.253-1.917-3.306-2.645z",
    fill: "#2c1c12",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.664 56.067c-.299-1.328-.664-2.636.08-4.278.418-1.365 2.37-2.49 3.955-2.743 2.44-.392 6.226.082 7.11 2.108.59 1.355.911 3.149-1.778 4.01-2 .735-3.925 3.18-6.139 3.485-.917-.88-1.223-1.872-3.228-2.582z",
    fill: "#d6b39d",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.641 55.018c.951-.353 1.25.956 1.21 1.331 2.148-1.776 4.582-3.647 5.408-3.318.354-2.193-6.28-3.123-6.618 1.987z",
    fill: "#181818",
    stroke: "#6f3f1e",
    strokeLinejoin: "round",
    strokeWidth: 0.12,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(535.4 -59.232) scale(1.27772)",
    d: "M228.162 161.857c-.72.001-1.362.378-1.601.94l-.052.173s-.1.236-.232.335c-.13.098-.493.295-.699.492-.323.308-.62.66-.82 1.058-.164.325-.295 1.05-.295 1.05s.323-.72.535-1.05c.2-.312.415-.623.69-.873.189-.172.644-.416.644-.416l.24.252-.166-.583c.124 1.048 1.048 1.432 1.756 1.433.939 0 1.7-.628 1.701-1.404 0-.777-.761-1.407-1.7-1.407z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.124,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(1000.82 159.586) scale(.16766)",
    d: "M-1037.191-71.64a12.953 10.716 0 0 0-11.229 5.392c-.191.309-.38.609-.574.934v.007c-.429.79-.74 1.62-.928 2.473 6.019 1.767 18.547 1.679 25.537.346a9.09 9.09 0 0 0-.28-1.143 12.953 10.716 0 0 0-.01-.035v-.01a9.46 9.46 0 0 0-.438-1.13 12.953 10.716 0 0 0 0-.004c0-.004 0-.007-.01-.01-.199-.371-.4-.72-.6-1.08a12.953 10.716 0 0 0-11.465-5.74z",
    fill: "#794d2f",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(1000.82 159.586) scale(.63366)",
    d: "m-276.2-15.99.155.55 3.04-.022s.507-.617.419-.55c-.088.065-3.613.021-3.613.021z",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.25,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(535.4 -59.232) scale(1.27772)",
    d: "M228.017 164.597a1.897 1.897 0 0 1-.979-.355 1.527 1.527 0 0 1-.396-.46 7.688 7.688 0 0 1-.176-.585c0-.005.013-.03.029-.057l.03-.05.067.016c.169.043.466.088.744.112a11.89 11.89 0 0 0 1.961-.018c.136-.013.435-.053.476-.064.02-.005.02-.005.02.117 0 .201-.036.355-.127.53-.273.533-.95.867-1.649.814zm.875-.95a.73.73 0 0 0 .112-.123c.135-.17.134-.168.125-.218-.007-.04-.009-.042-.043-.047a36.553 36.553 0 0 1-1.107.006l-.765-.005v.038c.001.054.086.341.106.356.014.01.141.012.783.006.473-.004.775-.009.789-.014z",
    fill: "#e6c74d",
    stroke: "#e6e600",
    strokeLinejoin: "round",
    strokeWidth: 0.001,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  })), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.34 67.392c-1.109-.122-2.062-.37-2.917-.76-.532-.243-.708-.459-.81-.996-.043-.224-.034-.349.053-.742l.104-.472.395.114c.6.174 1.243.236 1.757.169.496-.065.858-.164.847-.231-.004-.026-.023-.043-.041-.038a4.378 4.378 0 0 1-1.39.149c-.928-.052-1.59-.284-2.25-.79-.382-.292-.556-.568-.664-1.048-.06-.266-.058-.273.1-.506.233-.344.822-.908 1.109-1.062a2.7 2.7 0 0 1 .599-.206c.641-.133 1.082-.451 1.262-.91.097-.247.043-.434-.211-.722-.224-.254-.616-.545-.68-.505-.023.014-.03.255-.018.536l.022.51-.133.06c-.187.086-.495-.011-.627-.197-.14-.197-.461-.348-.754-.355l-.246-.006-.269.346c-.147.19-.299.39-.336.442-.037.053-.08.084-.094.069-.015-.015-.041-.28-.058-.59l-.03-.564.197-.32c.74-1.208 1.065-1.638 1.857-2.452.908-.934.81-.892 1.435-.604.38.175.63.427.717.719.03.102.09.408.134.68.043.272.13.608.194.747.17.373.903 1.093 1.314 1.293.377.183.95.309 1.412.309.208 0 .394.03.509.085.241.114 1.622 1.515 1.823 1.85.186.31.467 1.356.558 2.078.09.72.04 2.688-.08 3.129l-.094.344-1.78.259c-1.917.28-2.022.286-2.917.188z",
    fill: "#d4d4d4",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.09 53.863s1.19-3.004 2.51-3.696c1.715-.9 4.097-.854 5.812.048.55.29 1.07 1.532 1.07 1.532s-1.293-.695-2-.701c-2.054-.018-3.291-.07-4.754.57-1.058.463-2.637 2.247-2.637 2.247z",
    fill: "#c99472",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.223 74.672c2.736.196 4.69 0 5.471 0 .782 0-.586-.195.977 1.368 1.563 1.563 0 1.172 2.15 1.759s6.643.195 6.643.195-1.954 1.563-3.322 1.563-5.275-.39-6.448 0c-1.172.39-2.54 1.954-2.54 1.954l.586 1.954h-1.563l.586-4.103-1.758-2.736zm30.09-21.102s.782 1.759.782 3.126c0 1.368.586 1.954.586 1.954l.39 1.368 1.955.195 1.368 3.127s0-4.69 1.563-3.908c1.563.781 1.367-1.172 2.149.977.781 2.15 1.563 4.103 1.563 4.103s-1.172-1.954 1.172-2.15c2.345-.195 3.517-.78 3.713.392.195 1.172 0 1.367-.196 2.735-.195 1.368-.781 3.322-.195 2.345.586-.977.195-2.15 1.172-1.759.977.39.587-1.172 1.563 1.759.977 2.93.977 3.321.977 3.321s.391-.195.782-3.517c.39-3.321-.977-3.712.39-5.08 1.368-1.368 2.094-3.36 4.048-2.383 1.954.976 1.814-1.134 2.791 3.36.977 4.494 1.759 5.862 1.759 5.862s0-1.368-.196-4.69c-.195-3.321-.39-4.298-.39-4.298l-3.322-1.172s-5.275.781-6.057.781-3.322 0-4.69-.586c-1.367-.586-8.401-2.345-8.401-2.345l-4.494-2.54zm32.63 6.448c7.034 0 7.425-.39 11.724-.39s6.057-1.564 8.402-1.76c2.344-.195 3.712-.195 7.034-.195s3.126-1.758 8.792-.195 6.253 1.954 7.23 2.345c.976.39 4.689 2.735 4.689 2.735l4.494 4.494s-4.299-3.712-5.471-4.494c-1.172-.781-6.448-1.954-6.448-1.954s-1.172-.195-1.172 1.173c0 1.367 2.149 3.517 2.149 3.517l3.908 2.344 1.368 2.736-3.517-3.127s-2.15-.781-2.345.196c-.196.977.586 2.54.586 2.54s-2.15-2.345-3.126-4.299c-.977-1.954-1.563-3.321-2.736-4.103-1.172-.781-3.712-1.758-3.712-1.758s-5.08-1.563-4.299 0c.782 1.563.587.781 1.564 2.735.976 1.954 1.758 1.368 4.103 4.885 2.344 3.517 2.93 4.103 1.172 2.345-1.758-1.759-2.15-2.15-3.322-3.908-1.172-1.759-2.149-2.931-3.517-3.126-1.367-.196-1.758-1.368-1.758.195s-1.172.586 0 2.54c1.172 1.954.977 1.758 1.563 3.908.586 2.149 2.54 5.666 2.54 5.666s-1.758-.782-2.345-2.345c-.586-1.563-2.54-3.712-2.93-5.666-.391-1.954-1.954-4.103-1.954-4.103l-2.54-.39s-.587.78-.587 1.758c0 .977-.39-.782-.39 1.758s.195 1.563.586 4.69c.39 3.126 0 .976-.782-.391-.781-1.368-1.367-2.931-1.954-5.08-.586-2.15-1.172-3.517-1.172-3.517l-1.563 1.563-1.172-1.759s-1.954-.39-1.954.391c0 .782-.977 2.735-.977 4.494v5.666s-.977-2.93-.977-4.103c0-1.172-1.173-4.69-1.563-3.908-.391.782-2.736.782-2.736 1.759v2.344s1.173 0-.781-3.712c-1.954-3.712-4.104-4.494-4.104-4.494z",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)",
    fill: "#acacac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.783 75.98c0 1.658-.83 3.04-.967 5.665-.138 2.625-.691 3.454-.138 7.046.552 3.592 2.21 9.395 2.21 10.915s.138 5.526.415 0c.276-5.527-1.244-8.566-1.244-9.533 0-.968-.276-3.178-.276-6.356s.414-5.526.414-5.526l-.414-2.902zm8.842-3.73c.415 2.901.415 2.072-.138 6.217-.553 4.145-.829 5.803-.69 6.908.137 1.105.828 5.526 1.105 7.599s-.139 4.697.138 2.763c.276-1.934-.277-7.046-.277-9.671 0-2.625-.276-2.902 0-5.527.277-2.625.277-5.112.277-5.112zm7.323 4.006c0 1.935-.277 6.218-.277 8.428 0 2.21.553 5.527 1.244 8.014s.967 5.112.967 5.112 1.934-1.935 0-5.665-1.52-8.29-1.52-9.671-.414-6.218-.414-6.218zm6.632-5.941c0 1.658-.415 3.04.276 5.665s.967 1.934.552 4.145c-.414 2.21-.69 2.21-.69 4.145s.138 3.177.138 3.177-.138-3.454.414-4.42c.553-.968.967-3.87.967-4.836s-.69-1.796-.829-2.625c-.138-.83-.69-2.902-.69-2.902zm9.809 4.975c0 1.519-.829 3.315-.553 6.217.277 2.9-.829 2.625 1.106 5.25 1.934 2.625 1.796 3.04 3.04 5.112 1.243 2.072 2.348 6.217 2.348 6.217s-.967-6.494-1.382-7.046c-.414-.553-2.763-4.56-2.901-5.389-.138-.829-1.105-1.796-1.382-3.04-.276-1.243-.276-7.322-.276-7.322zm9.119 1.105c1.105 2.348.69 1.52 1.381 5.25.691 3.73-.138 3.04.83 6.079.966 3.04 1.519 4.56 2.348 6.355.829 1.796.69 1.796 2.072 4.283 1.382 2.487 2.073 4.56 2.35 5.803s.828-.69.275-2.349-1.381-3.316-2.072-5.803c-.69-2.486-2.072-4.283-2.487-5.802-.414-1.52-1.796-3.316-1.796-4.283s-.967-5.941-.967-5.941l-.83-2.073zm-55.403-4.56c0 1.658-1.382 4.421-1.244 6.494s1.244 6.77 1.382 7.322c.138.553.83 2.35 1.105 4.698.277 2.349.277 4.145.691 2.349s.138-7.047-.552-9.12c-.691-2.071-1.52-2.486-1.52-4.282v-3.454c0-.83.138-4.007.138-4.007zm-26.113-1.243c2.211-.138 3.73-.691 5.941-1.934 2.211-1.244 4.145-4.145 4.56-4.698.414-.553 1.243-4.56 1.243-3.592s.276 3.04-1.105 5.112c-1.382 2.072.967 1.381-2.487 2.901-3.454 1.52-1.382 1.105-3.73 1.658-2.35.553-4.422.553-4.422.553zm-.69 12.572c1.796-.829 5.802-1.243 7.184-3.454 1.382-2.21.138-2.348 2.21-3.868 2.073-1.52 1.382-.69 3.455-2.901 2.072-2.211 2.625-3.869 2.625-3.869l-2.21 4.697s-1.52-.276-2.488 2.35c-.967 2.624-.414 2.348-1.381 3.591-.968 1.244 2.487.139-1.658 1.658-4.145 1.52-5.803 1.382-5.803 1.382zm9.948 3.731c1.519-.276 3.039-1.244 4.42-3.592 1.382-2.35 2.073-4.007 3.454-5.25 1.382-1.244 2.764-4.422 2.764-4.422s-.277 3.869-.691 4.421c-.415.553-2.625.968-2.763 1.935-.139.967.138 1.105-.553 2.348-.69 1.244-.829 1.244-1.243 1.935s-1.797 1.796-1.797 1.796l-2.072.552zm79.028-10.5c.276 1.796.828 4.697 1.796 6.079s3.04 4.42 3.73 6.217c.69 1.796 2.349 7.737 2.349 7.737s.138-3.592-.138-4.56c-.277-.967-1.106-3.039-1.382-4.144-.276-1.106-1.658-3.592-2.072-4.421-.415-.83-1.797-2.073-1.935-2.902-.138-.829-2.348-4.006-2.348-4.006zm3.177-2.764s.967.277 1.658.691c.691.415 2.349.138 3.178.83.829.69 2.21 1.38 2.487 2.486l.414 1.658s-.967-1.796-1.934-2.487c-.967-.69-2.21-1.105-3.454-1.52-1.243-.414-2.21-.829-2.21-.829z",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.056 111.398c1.796-.414 1.535 1.886 5.818 1.471s6.908-2.072 7.461-3.04c.553-.967.553-5.388 1.105-4.973.553.414.967 3.592 1.935 4.006.967.415 1.381 1.658 2.763.415s2.072-1.658 2.21-2.901c.139-1.244-.138-4.283.553-3.73.69.552 2.487 5.526 2.487 5.526s0-4.56.829-3.454 2.072 4.006 2.072 4.006.825-3.331 1.978-3.463c.643-.074 1.481 2.126 3.262 2.72 4.974 1.657 3.004.4 4.938 1.366 1.935.967-.68-2.538 2.498-2.538 1.276 0 1.527 2.359 2.445 3.129 1.366 1.146 1.986-.974 1.986-.974s2.374-2.727 2.789-3.417c.414-.691-.553-6.356.967-3.04s3.66 4.318 3.66 4.318l1.469.992s2.055-1.303 2.608-1.165c.552.138 1.661.503 2.352.503.69 0 1.424-1.317 1.972-1.939l1.637-1.859s-.348-2.505 3.405-2.79c1.765-.283 2.516 5.256 3.897 5.532 1.382.277-1.913-6.139.436-4.343 2.348 1.796 2.051 4.343 3.709 5.449 6.347 10.134.723 1.366 1.35 2.12l2.357 1.964s1.292 3.77.197 4.309c-1.83.9-2.463-1.337-2.463-1.337s-3.652-4.017-5.724-4.155c-2.072-.138-3.454-1.796-7.323 0s-2.348 1.105-5.664 2.349c-3.316 1.243-3.869 1.934-6.356 1.796-2.486-.138-3.713.758-6.338.758s.865-.598-4.186.293c-3.975.7-7.906 1.341-11.406.968-1.001-.106-1.967.564-2.888.073-.91-2.442 1.156-2.524 1.055-3.75-2.848.855-3.204.96-4.56 1.793-2.072 2.764-.664 2.736-2.46 3.842-1.797 1.105-3.619 3.483-3.619 3.483s-.276.415-2.487-2.072c-2.21-2.487 1.411-.412-2.872-1.517-4.283-1.105-.551-1.434-4.005-1.849-.347.15-2.087-1.602-2.087-1.602z",
    fill: "#acacac",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.236 97.543s.007 2.327-.564 3.44c-.57 1.112-1.37 0-3.88.278-2.511.278-1.484 3.06-1.484 3.06l-2.054 2.782-.913.557-4.565 1.298s-2.511 0-3.767-1.02c-1.255-1.02-1.14-.742-2.168-1.484-1.027-.742-2.283 1.298-2.625 1.855-.342.556-1.94 2.133-3.766 2.318-1.826.186-1.598-2.225-2.283-3.06s-.228 1.391-.913 2.411c-.684 1.02-1.255.186-3.652-.835-2.396-1.02-2.625.279-2.625.279l-3.88-3.432s-.228 1.948-.799 4.266c-.57 2.319-2.282 2.875-3.081 5.75-.13.467-.617.534-.723.863.09.045 1.062.55 1.801.55.314 0 .782-.852 1.43-.771 1.003.124 1.877.952 2.938 1.004.538.026 1.556-.36 1.556-.36s2.276.446 3.424.372c.792-.052 2.283-.557 2.283-.557s1.26.927 2.054 1.02c.585.069 1.712-.37 1.712-.37s1.498.656 2.283.556c.73-.093 1.826-1.02 1.826-1.02s2.042.578 2.967.278c.552-.18 1.141-1.113 1.141-1.113s1.234 1.596 2.169 1.484c.897-.108 1.255-1.299 1.483-1.855.229-.556 2.741-.278 2.741-.278l2.288-.244 2.049-.869 1.255-.742s1.801-.66 2.74-.649c.982.01 1.874.827 2.853.742.666-.058 1.172-.692 1.826-.835 1.115-.243 2.321-.295 3.423 0 .859.23 2.31 1.332 2.31 1.332-.02-.036 2.317.036 2.3.004-.767-.267-4.607-1.672-5.099-4.916-.798-2.967-.642-1.547-2.011-4.236s-2-7.852-2-7.852zm-57.359 16.207c1.367 0 3.223-.586 3.419-.977.195-.39.098-1.367.488-1.27.391.098.293 1.466 1.075 1.563s3.615-1.856 2.735-.684c-.879 1.173-2.93 1.368-3.028 2.54-.098 1.173-.684 1.661-.684 1.661s-.684-1.367-1.172-1.563c-.489-.195-2.833-1.27-2.833-1.27z",
    fill: "#959595",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.372 64.726a4.698 4.698 0 0 1-.932-.121 2.34 2.34 0 0 1-.413-.174 2.696 2.696 0 0 1-.205-.113c-.003-.004.023-.004.085-.002a.355.355 0 0 1 .115.013c.103.041.268.093.41.128.25.063.494.1.834.127.126.01.525.008.643-.003.251-.023.48-.06.718-.118.054-.013.103-.024.109-.024.013 0 .03.02.03.036 0 .054-.23.128-.589.189-.329.056-.502.07-.805.062z",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.625 94.197c-.512.324-.923.798-1.166.96-.513.342.114 2.51.171 3.424.058.913-1.426 2.054-2.91 2.34s-.628 2.966-1.084 4.336c-.457 1.37-.457 2.739-.799 3.766s-2.625 1.883-2.91 2.853c-.186.63.235 1.934.863 3.178.335-.134.661-.314 1.006-.396 1.136-1.028.675-2.255.684-3.424l2.625-1.597 1.37-2.74c.588-1.374.158-3.003-.457-4.679l2.169-.684.114-5.136.342-.457V94.23z",
    fill: "#959595",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.153 108.022c.893.068 3.845 1.51 4.6 2.678.756 1.167.276 1.785 2.061 3.502 1.785 1.717 4.326 2.61 4.601 2.747.275.137 1.236.961 3.159 1.373 1.923.412.893 1.236 1.991.824 1.1-.412 1.03-.824 1.923-1.991s1.854-2.678 2.404-3.022c.549-.343 1.098-1.373 1.167-2.678.069-1.305 1.167-.961.069-3.227-1.099-2.266-3.434-5.7-3.914-7.142-.481-1.442-1.443-3.571-1.786-3.434s-4.12.962-4.807 1.923c-.687.961-3.502 2.678-3.983 3.228s-3.296 2.197-3.777 2.746c-.48.55-3.433 2.541-3.708 2.473z",
    fill: "#e5e5e5",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.892 105.53c2.929-.144 2.764-.556 4.55-.556 1.785 0 .272.113 3.293.113s3.846-.274 5.494-1.236c1.648-.961 3.296-3.433 3.296-3.433s-1.375 2.278-2.886 3.789c-1.51 1.51-2.398 1.477-4.184 1.34-1.785-.138-4.741-.047-4.741-.047l-6.593.549zm4.272 3.952s2.753.105 4.129.057c1.653-.057 3.369.091 4.944-.412 1.062-.339 2.876-1.705 2.876-1.705s-1.316 1.039-2.052 1.43c-.913.487-1.873.95-2.892 1.123-1.533.26-3.113-.025-4.662-.161-.785-.069-2.343-.332-2.343-.332zm4.67 4.121s1.648.55 3.433 0c1.786-.55 1.649-.55 3.297-1.236 1.648-.687 2.61-1.649 2.06-1.1-.55.55-2.747 1.649-2.747 1.649l-3.434.824z",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)",
    fill: "#c9c9c9",
    stroke: "#b3b3b3",
    strokeLinejoin: "round",
    strokeWidth: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.237 37.37 1.653-.64c-.622-.892-.775-1.892-.746-2.934.685.626 1.242 1.321 1.846 2.148-1-1.25-.93-1.899-.874-3.12l1.268 1.932c-.061-.645-.203-1.265.267-2.08.569.563.67 1.438.8 2.294.092-.646.276-1.1.703-1.723.34.688.391 1.54.382 2.426.233-.637.456-1.283.86-1.773.18.563.285 1.494.22 2.13.189-.832.776-1.016 1.437-1.079.106.214.072.53-.198 1.02.366-.397.762-.778 1.45-1.001-.038.396-.084.793-.516 1.215.7-.71 1.173-1.514 2.382-2.015l-.773 2.18c.532-1.056 1.221-2.064 2.747-2.82.002.498-.025.991-.32 1.44.53-.844 1.38-1.413 2.614-1.654-.083.558-.476 1.046-.907 1.494.67-.588 1.266-1.312 2.507-1.547l-1.067 1.653c.785-.509 1.465-1.19 2.507-1.28.136.25-.96 1.334-.96 1.334s2.249-1.902 3.467-1.814c-.348.811-.697 1.288-1.547 1.867.704-.518 1.265-1.21 2.294-1.333-.131.469.19.88-.64 1.44.617-.26 1.244-.677 1.813-.12.084-.444.254-.757.48-.987.637.498.799.716 1.014 1.213-.166-.627-.1-1.203.053-1.76.85.5.623 1.293.76 1.987.123-.753-.318-1.682.733-2.147a2.64 2.64 0 0 1 .267 1.494c.796-.32 1.32-.658 1.547-1.014.308.126.349.426-.053 1.014.64-.544 1.28-1.251 1.92-1.12-.11.29-.144.663-.347 1.2.604-1.06 1.176-1.266 2.214-1.36-.082.451-.489 1.042-1.067 1.706 1.085-1.42 2.204-2.081 3.36-1.866-.293.641-.452 1.307-1.493 1.813.888-.47 1.75-1.207 2.773-.32-.546.605-1.473.878-2.587.987l2.534 2.32-.107 2.294-34.83-.587z",
    fill: "#3d6c1e",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(655.612 92.308) scale(4.82918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.372 37.121s.967.327.854-.05c-.113-.377-.49-1.17-.49-1.17s.34-.15.528 0c.188.152.49.303.49.303l.113-.453-.452-.49s.188-.264.377 0c.188.264.302.415.49.565.189.151.717.49.717.49l.34-.452.339.34.49-.566.264.83.792-.68s-.038.378 0 .566c.038.19-.113.68.226.529.34-.151.943-.68.943-.68s-.377.642-.15.717c.226.076.188.415.527.076.34-.34.34-.378.604-.642.264-.264.377-.905.377-.377s.038.755.038.755.037.264.264.226c.226-.038.34-.113.528-.302s.302-.641.566-.716c.264-.076.49-.038.83-.227.339-.188.867-.415 1.018-.415.15 0-.378-.264.377.076.754.34.867.264 1.018.377s.189.075 1.094.566c.905.49.741-.857.741-.857s2.179 2.421 2.427 2.442c.195.016-.94-1.303-.777-1.273.432.078 1.041.706 1.041.706l.178-.45-.961-.647 1.301.03-.622-.596-.038-.377s.34-.038.49.037c.151.076-.188.453.754.415.943-.037.981-.15.981-.15s.302-.151.49.188-.008-.11.52.08c.528.188.377.565.566.15.188-.415.226-.641.226-.641l.34.83s.263.188.301.037c.038-.15.15-.528.15-.528l.265.566.226-.264.227-.34.565-.188.528-.15.302.188.189-.113.415.037.339-.113.34.151.377.15.49.303s-.302.113.302-.038c.603-.151.679-.453 1.131-.453.453 0 1.132-.264 1.358-.15.226.113.188-.227.453.263.264.49.301.264.49 1.056.188.793.188.68.188 1.622s-.075 1.434-.075 1.434l-8.977-.038-13.087-.264-5.28-.038-1.961-.438-.44-.966.913.272z",
    fill: "#294814",
    stroke: "#007300",
    strokeLinejoin: "round",
    strokeWidth: 0.033,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(655.612 92.308) scale(4.82918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.26 37.487.393 2.945 1.513.914 2.469.025.047-1.75-.579.28.393-.94-.675.16.2-.62-.827.293-.24-.854-.426.534-.134-.747-.4.48.053-.72-.533.507-.187-.747-.346.907zm15.682-.374.154 1.35-.739-.666.372 1.77 1.256.943 2.592.628-.107-.597.147-.772.665-.339-.633-.583-.56.267v-.507l-.506.347-.054-1.2-.65.92.01-.867-.766.445.046-.952-.36.455-.28-1.068-.24.746zm4.214 1.787 1.52.827 2.498-.771-.31-2.27-.428.667-.16-.72-.346.614-.56-.667v.8l-.747-.88v1.36s-.854-.747-.854-.64c0 .107.134.694.134.694l-.667.053.747.507z",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(655.612 92.308) scale(4.82918)",
    fill: "#98b432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.566 34.928c.038.188-.075.17.226.641.302.472.264.453.49.811.227.358.302.547.302.547l-.716.188 1.018-.094.264-.075s-.377-.245-.415-.34c-.038-.094-.49-.603-.547-.848-.056-.245-.32-.66-.32-.66z",
    fill: "#3d6c1e",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(655.612 92.308) scale(4.82918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.51 34.796c0 .075.094.094.188.377.094.283.207.547.245.622.038.076.208.415.302.528.094.114.302.302.302.302l-.189-.735s-.245-.434-.283-.566c-.038-.132-.566-.528-.566-.528zm.754-.981c-.02.076-.033.51.042.623s.052.207.203.49c.15.283.377.641.377.641zm1.358-.641s-.127.398-.132.604c-.009.312.15.924.15.924zm1.508.396.18.82.08 1.046s-.38-.66-.346-.74c.033-.08.087-1.126.087-1.126zm1.194.76.134.686-.02.76s-.174-.45-.194-.686c-.021-.254.08-.76.08-.76zm1.554.84.02.32-.114.353-.26.087.14-.207s.087-.227.094-.253c.006-.027.12-.3.12-.3zm1.267.013c.013.027-.014.333-.014.333l-.2.407-.406.347.28-.42.24-.38zm1.746-.717s-.188.452-.188.51c0 .056-.283.848-.283.848l-.16.415s-.613.358-.557.348c.057-.009.387-.282.453-.414s.264-.736.311-.802c.047-.066.245-.66.245-.66zm2.122-.632c.01.066-.057.538-.085.66-.028.123-.132.33-.18.434a4.856 4.856 0 0 1-.348.547c-.075.094-.34.226-.415.302-.075.075-.273.17-.358.282-.085.114-.415.519-.415.519s.066-.33.15-.462c.086-.132-.018-.255.255-.424.274-.17.444-.236.51-.293.066-.056.207-.245.292-.367s.283-.576.311-.613c.028-.038.283-.585.283-.585zm2.187-.274c0 .057-.103.359-.141.406-.038.047-.198.283-.273.387-.076.103-.264.264-.321.32-.057.057-.047.123-.245.245-.198.123-.302.16-.415.217-.113.057-.415.217-.415.217s.32-.32.462-.386c.142-.066.34-.151.453-.34s.48-.566.48-.566.057-.16.199-.235c.141-.076.216-.264.216-.264zm1.575-.065c-.075.085-.15.103-.254.273-.104.17-.151.208-.264.415-.114.207-.17.255-.264.424-.095.17-.142.274-.236.368-.095.094-.557.311-.557.311s.123-.17.283-.292c.16-.123.217-.311.34-.472.122-.16.518-.754.518-.754zm1.518.301c0 .038 0 .132-.122.246-.123.113-.264.198-.321.273-.057.075-.094.057-.283.283-.188.226-.32.292-.434.462-.113.17-.546.415-.546.415s.245-.198.424-.387c.179-.188.16-.358.386-.528.227-.17.302-.226.453-.349s.443-.415.443-.415zm2.508-.499a5.094 5.094 0 0 1-.254.452c-.132.217-.217.283-.32.443-.105.16-.161.255-.237.444-.075.188-.047.207-.15.33-.104.122-.264.188-.444.245a7.81 7.81 0 0 1-.631.16c-.217.047-.472.208-.472.208s.236-.227.387-.302c.15-.076.377-.189.547-.255.17-.066.396-.179.48-.273.085-.095.217-.33.265-.434a3.16 3.16 0 0 1 .33-.462c.047-.047.141-.207.179-.273.037-.066.32-.283.32-.283zm.745.622c-.019.075-.141.15-.132.32.01.17.047.283.01.368-.038.085-.066.113-.189.217s-.283.123-.349.255-.113.179-.113.179.038-.302.141-.434c.104-.132.198-.198.283-.264.085-.066.104-.132.132-.245.029-.113.02-.207.057-.255.038-.047.16-.141.16-.141zm1.848.339s-.141.132-.16.283c-.019.151-.113.35-.066.5.047.15.075.18.085.075.01-.103 0-.254.056-.348.057-.095.132-.387.132-.387zm1.152-.448c-.04.146-.133.08-.133.346 0 .267-.04.227 0 .44.04.214.027.387.107.614.08.226.146.386.146.386s-.053-.426-.04-.533c.014-.107-.013-.347.014-.507.026-.16 0-.373 0-.453 0-.08-.094-.293-.094-.293zm1.227-.24s-.187.04-.227.16c-.04.12-.173.08-.173.4s-.013.186-.013.44c0 .253-.027.72-.027.72s.093-.094.107-.307c.013-.213-.014-.4.04-.573.053-.174.04-.334.093-.427.053-.093.2-.413.2-.413zm2.01.496c-.01.084-.011.17-.036.25-.033.105-.014.067-.147.294-.133.226-.28.333-.28.333s.335-.275.453-.453a.6.6 0 0 0 .12-.294c.005-.103-.093-.296-.093-.296s-.01.11-.017.166zm1.587-.286c-.007.073-.033.206-.043.316-.01.11-.054.19-.074.334-.02.143-.033.22-.086.3-.054.08-.074.073-.204.196-.13.124-.14.197-.026.127.113-.07.203-.113.266-.207.064-.093.12-.306.16-.416.04-.11.054-.264.07-.364s-.016-.21-.016-.223c0-.013-.047-.063-.047-.063zm1.814-.094c-.01.074.023.177-.014.277-.036.1-.08.183-.123.307-.043.123-.14.2-.227.34a1.06 1.06 0 0 1-.226.28c-.094.083-.384.186-.384.186s.314-.243.397-.316c.083-.074.103-.244.217-.37s.153-.264.196-.33c.044-.067.087-.207.097-.227l.067-.147zm2.356-.21c-.028.047-.066.085-.113.245-.047.16-.057.245-.142.368-.084.122-.198.235-.273.377-.075.141-.15.198-.264.32-.113.123-.65.293-.65.293s.188-.104.377-.283c.188-.18.292-.368.396-.519.103-.15.15-.386.32-.537.17-.151.349-.264.349-.264zm1.207 1.367c-.132.066-.207.066-.358.217-.151.15-.49.254-.65.302-.161.047-.604.085-.68.103-.075.02-.67.076-.67.076s.152.113.397.104c.245-.01.405-.095.584-.104.18-.01.32-.104.443-.113.123-.01.51-.189.547-.217.038-.029.151-.066.227-.151.075-.085.16-.217.16-.217z",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(655.612 92.308) scale(4.82918)",
    fill: "#98b432"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M814.068 267.333c-18.062 0-24.082 15.755-42.143 15.755v31.513c3.192-.985 30.103-15.755 42.143-15.755 12.042 0 30.103 15.755 42.143 15.755 12.042 0 29.811-15.755 42.143-15.755 12.042 0 34.193 15.755 48.166 15.755 18.062 0 26.456-15.755 42.144-15.755 12.041 0 26.522 15.447 36.122 15.755 0-10.503 1.358-30.037 1.358-30.037l-.492-1.293c-5.155.184-18.927-15.938-36.988-15.938s-30.104 15.757-45.988 15.078c-15.883-.679-26.26-15.078-44.322-15.078-18.061 0-24.081 15.755-42.143 15.755s-24.081-15.755-42.143-15.755zm.25 64.878c-12.334.117-32.754 16.584-34.468 16.829 1.623.829 15.716 25.31 15.716 25.31s5.722-3.281 18.061-5.253c12.341-1.972 25.23 11.291 39.707 13.523 14.478 2.233 32.2-13.523 44.58-13.523 12.042 0 28.438 16.543 44.322 13.523 15.883-3.019 22.078-20.002 37.043-19.388 14.964.612 20.985 5.865 20.985 5.865l18.061-21.01s-18.076-14.277-33.12-15.016c-15.044-.74-21.063 15.016-39.125 15.016-24.082 0-30.213-15.755-48.166-15.755-18.062 0-24.082 15.755-42.143 15.755s-28.723-15.998-41.453-15.876zm85.704 73.642a29.836 29.836 0 0 0-1.689.003c-18.358.538-24.981 15.755-49.964 15.755 0 1.293 43.72 21.01 49.964 21.01 6.248 0 60.714-22.165 49.97-21.01-24.202 0-31.178-15.291-48.28-15.758z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M371.26 257.747c-11.974-2.269-21.447-8.584-28.097-18.733-3.566-5.44-5.996-11.186-6.574-15.537-.333-2.504-.96-2.928-3.597-2.434-1.488.279-1.782.15-3.199-1.394-.857-.935-1.56-1.828-1.562-1.984 0-.155-.32-.889-.706-1.63-.386-.74-.594-1.779-.46-2.309.211-.843-.248-1.175-3.674-2.662-2.154-.934-4.174-1.797-4.488-1.918-.417-.16-.29 1.114.467 4.689 1.069 5.04 1.072 5.588.03 5.588-.539 0-1.414-1.987-1.239-2.814.091-.43-1.582-8.536-1.794-8.692-.434-.318-9.856-4.37-10.163-4.37-.599 0-12.538-6.903-12.318-7.123.247-.246 8.749 3.299 16.392 6.835 2.989 1.382 5.508 2.44 5.599 2.348.09-.09-.157-1.883-.551-3.983-.87-4.634-.875-4.881-.112-4.881.395 0 .946 1.534 1.589 4.423.54 2.432 1.05 4.7 1.132 5.038.188.783 6.112 3.57 20.517 9.656 3.497 1.477 6.713 2.883 7.147 3.124.433.242 1 .44 1.258.44.658 0 .477-13.27-.188-13.715-.341-.23-.319-.336.071-.34 1.066-.014.57-1.65-.807-2.667l-1.376-1.015-1.183.93c-1.597 1.254-3.076 1.172-4.182-.232-.822-1.044-1.077-1.118-2.5-.726-1.293.357-1.634.306-1.857-.276-.337-.875.355-1.333 2.586-1.71.942-.158 1.712-.428 1.712-.599 0-.17-.584-1.02-1.298-1.888-2.39-2.904-3.38-5.408-3.583-9.062-.163-2.942-.039-3.693.922-5.556.744-1.445.922-2.155.54-2.155-.505 0-1.34-1.314-1.02-1.603.11-.098 5.113-1.465 10.684-2.918 1.765-.46 1.93-.628 1.93-1.96 0-1.127-.368-1.75-1.624-2.751l-1.624-1.295-1.017.954c-1.331 1.25-3.056 1.211-4.285-.095-1.88-2-1.637-2.202 4.462-3.733l3.86-.969v-1.51c0-1.605-1.04-2.506-4.173-3.617-1.254-.445-1.779-.358-3.904.646-3.02 1.427-3.115 1.428-4.789.021-2.325-1.954-3.588-2.421-5.423-2.008-2.422.546-2.38.125.095-.97 1.737-.767 2.655-.894 4.726-.656 2.204.254 2.946.123 5.223-.92 2.619-1.2 2.69-1.207 5.45-.529 1.537.378 2.898.578 3.023.444.125-.133-.029-.334-.34-.445-.313-.111-.569-.492-.569-.845 0-.466.603-.643 2.188-.643h2.188l-.195 4.99c-.107 2.744-.12 4.99-.03 4.99.092 0 1.597-.426 3.344-.947 1.748-.52 3.685-1.017 4.304-1.105 1.297-.184 1.999.616 1.29 1.47-.266.32-.355.581-.197.581.157 0-.26.613-.928 1.361-1.227 1.376-3.153 1.814-4.048.921-.752-.751-3.828 3.837-3.828 5.71 0 1.304.145 1.554.795 1.368 2.437-.699 11.026-3.009 11.184-3.009.703 0 .568 1.58-.205 2.406-.513.548-1.683 2.51-2.6 4.36-1.332 2.69-1.662 3.87-1.648 5.896.02 2.837 1.396 5.976 3.772 8.61.765.847 1.296 1.692 1.182 1.877-.115.185-.885.463-1.713.618-1.198.224-1.621.605-2.078 1.865-.669 1.848-1.85 2.61-3.736 2.413-1.12-.117-1.604.181-2.862 1.77-.833 1.05-1.655 1.768-1.829 1.595.15 7.366.017 11.868-.2 17.144-.07 1.977.133 2.604 1.357 4.214 3.627 4.769 9.99 9.823 13.189 10.476.333.068.912.24 1.287.382.375.142 1.499.365 2.498.495.999.13 2.327.372 2.952.537.624.165 1.708.406 2.41.536l1.273.236c-.14-10.017-.029-20.039-.197-30.055-.074-3.525-.183-3.95-1.302-5.049-1.193-1.171-1.24-1.18-2-.34-.99 1.092-2.772 1.093-4.428.002-.71-.468-1.702-.744-2.204-.612-.515.134-1.086-.037-1.313-.394-.616-.973-.495-1.313.467-1.313.485 0 .996-.185 1.137-.412s-.497-2.625-1.417-5.33c-1.323-3.893-1.678-5.64-1.704-8.39-.03-3.229.102-3.729 1.894-7.173 1.642-3.158 1.793-3.66 1.021-3.415-.699.221-.904.079-.904-.63 0-.649.431-1.035 1.476-1.321.812-.223 3.264-.876 5.45-1.451l3.974-1.046v-1.52c0-1.186-.188-1.518-.858-1.518-.472 0-1.323-.375-1.89-.834-1.002-.81-1.056-.81-1.867 0-1.09 1.088-2.248 1.055-3.726-.106-2.493-1.959-1.6-2.716 5.048-4.28 3.103-.73 3.293-.846 3.293-2.024 0-1.084-.384-1.438-2.895-2.673-3.517-1.73-4.555-1.764-7.28-.243-2.541 1.419-3.521 1.261-6.235-1.004-1.888-1.575-2.084-1.634-4.702-1.417l-2.731.226 2.27-1.095c2.014-.97 2.663-1.062 5.733-.81 3.151.257 3.659.177 5.673-.894 2.542-1.351 4.797-1.486 8.108-.482 1.567.474 2.087.514 1.703.13-.978-.976-.6-1.277 1.604-1.278h2.158l-.152 4.921-.152 4.922 4.357-1.137c2.396-.625 4.476-1.018 4.621-.872.553.551-1.008 3.66-2.489 4.958-1.524 1.336-2.65 1.491-4.629.637-.922-.399-1.783 1.415-1.783 3.756v1.72l6.471-1.745c3.56-.96 6.727-1.648 7.04-1.528.649.248.78 1.606.153 1.606-.625 0-4.487 8.142-5.081 10.712-.446 1.93-.386 2.788.42 5.974 1.18 4.662 2.556 7.809 3.412 7.809.361 0 .782.322.933.717.383.995.4.968-.81 1.27-.654.165-1.197.72-1.368 1.402-.156.621-1.003 1.848-1.882 2.726-1.681 1.679-3.14 2.002-4.867 1.078-.827-.442-1.073-.361-1.674.548a20.273 20.273 0 0 1-1.68 2.123c-.961 1.04-.977 1.321-1.026 18.276l-.049 17.22 2.615-.02c1.439-.01 3.535-.217 4.66-.458 1.123-.242 2.554-.551 3.178-.688.625-.136 1.729-.542 2.454-.901.726-.36 1.584-.654 1.908-.654.324 0 .752-.292.952-.648.2-.357.525-.642.723-.634 3.72-2.249 5.33-3.515 7.78-4.586.572-.474.716-5.555.716-5.555s-.41-9.008-.44-16.221c-.026-1.184.269-1.335.44-2.294 0-.749-.242-1.361-.538-1.361-.297 0-.992-.426-1.547-.946-.97-.911-1.052-.917-2.214-.156-1.153.754-1.282.75-2.882-.074-.921-.475-2.492-.864-3.491-.865-1.26 0-1.817-.196-1.817-.64 0-.357.803-.87 1.817-1.16 2.085-.597 2.09-.656.498-4.87-.632-1.672-1.39-4.345-1.684-5.94-.48-2.604-.435-3.228.447-6.13.54-1.777 1.115-3.574 1.276-3.993.239-.623.076-.72-.894-.536-.801.153-1.274.002-1.453-.463-.364-.949-.145-1.043 6.563-2.818l5.919-1.566v-1.705c0-1.386-.165-1.705-.883-1.705-.485 0-1.194-.445-1.576-.99-.654-.932-.743-.945-1.537-.226-.464.42-1.2.762-1.633.762-1.593 0-4.052-1.908-3.753-2.912.068-.23 2.156-.952 4.64-1.606l4.515-1.188.136-1.608c.127-1.495-.009-1.684-1.938-2.703-2.021-1.068-2.111-1.075-3.466-.302-1.89 1.078-2.819 1-4.457-.377-1.11-.933-1.695-1.115-2.874-.893l-1.48.279 1.303-.738c.844-.478 1.963-.668 3.179-.54 1.28.134 2.447-.087 3.67-.694 1.529-.759 2.1-.82 3.86-.419 1.875.429 3.324.255 1.953-.234-.312-.111-.567-.491-.567-.845 0-.465.601-.642 2.178-.642h2.178l-.189 4.309c-.103 2.37-.009 4.31.216 4.31.347 0 5.59-1.373 7.992-2.092.577-.173.795.018.795.695 0 1.003-.807 2.173-2.934 4.252-1.053 1.03-1.642 1.268-2.725 1.1-1.182-.185-1.527.007-2.402 1.347-1.108 1.696-1.381 4.23-.454 4.213.786-.014 10.198-2.576 10.776-2.933 1.226-.757.848 1.46-.793 4.646-3.78 7.34-3.986 9.63-1.412 15.755 1.222 2.907 1.573 3.384 2.319 3.148.716-.227.85-.087.728.758-.105.722-.579 1.146-1.563 1.4-.905.232-1.872 1.027-2.695 2.212-1.443 2.08-3.464 3.328-4.735 2.925-.619-.196-1.07.105-1.665 1.111-.448.759-.965 1.38-1.148 1.38-.182 0-.3.816-.26 1.814.142.561.096 1.156.074 1.734-.009.643.624 1.547.294 1.026-.248-.39-.423 3.05-.447 8.803-.04 9.415-.037 9.441.868 8.623.5-.452.908-1.096.908-1.431 0-.336.252-.56.56-.497.37.074.563-.505.568-1.697 0-1.109.227-1.834.575-1.871.312-.034.772-.087 1.022-.118.663-.082.159-.716.24-1.599-.177-1.098-.086-1.576-.112-2.177.085-1.325.473-2.177-.118-2.177a.46.46 0 0 0-.465.453c-.483-.907-.082-.357-.547-1.214-.123-.47.043-1.934.37-2.238.477-.446 9.6-1.937 13.575-2.625l1.249-.215c.187-.032.34-1.768.34-3.859 0-3.774-.009-3.804-1.33-4.35-1.047-.434-1.661-.43-2.9.017-1.403.507-1.7.467-2.764-.368-.694-.545-1.568-.838-2.094-.7-.497.13-.903.033-.903-.214 0-.57 2.295-1.044 3.513-.726.507.132 1.546-.082 2.31-.476.762-.394 1.654-.632 1.982-.53a29.66 29.66 0 0 0 1.846.459l1.248.273v4.981c0 5.833-.641 5.46 6.586 3.825 2.747-.62 5.813-1.176 6.812-1.234 1.79-.103 1.815-.083 1.745 1.411-.044.944-.415 1.756-.984 2.154-1.95 1.364-2.324 10.57-.47 11.56.947.507 1.163 2.652.277 2.752-.313.036-3.24.014-6.506-.049l-5.938-.112-1.444 4.032c-4.21 11.753-13.254 22.342-23.466 27.472-3.203 1.609-8.516 3.458-12.255 4.267-4.626 1-15.515 1.209-19.88.382zm-26.11-60.186c2.038-.491 2.158-.604 2.158-2.03 0-.83-.136-1.51-.301-1.51-.565 0-4.562 2.73-5.424 3.706-.856.967-.854.971.275.664.625-.17 2.106-.543 3.293-.83zm26.568-.427 3.747-.982v-1.958c0-1.67-.117-1.917-.795-1.676-1.067.38-6.14 3.96-6.891 4.864-.778.937-.518.92 3.94-.248zm28.725.136c2.894-.815 2.955-.864 3.093-2.494.077-.914-.035-1.662-.252-1.662-.515 0-4.063 2.326-5.793 3.798-1.66 1.412-1.054 1.485 2.952.358zm-44.799-2.538c2.21-.607 4.132-1.22 4.274-1.36.141-.142-1.922-.258-4.587-.258h-4.844v1.36c0 1.65.079 1.654 5.157.258zm32.233-1.927c2.453-.52.189-1.038-4.578-1.045l-4.655-.007v3.543l3.974-1.109c2.185-.61 4.552-1.231 5.26-1.382zm23.627 1.474c2.21-.607 4.132-1.22 4.274-1.361.142-.142-1.808-.258-4.333-.258-2.525 0-4.695.17-4.822.375-.286.463.175 2.347.575 2.347.16 0 2.098-.497 4.306-1.103z",
    color: "#000",
    fill: "#280b0b",
    stroke: "#280b0b",
    strokeWidth: 0.99,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "translate(403.423 82.951) scale(1.3183)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M900.986 444.359s-132.072-29.614-131.336-152.76V118.033l258.776-.002 1.947 172.633c.736 123.145-129.387 153.696-129.387 153.696zm-.185-5.493S773.868 409.35 774.603 286.204l.972-162.78h247.276l1.701 161.845c.736 123.145-123.75 153.597-123.75 153.597z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.234
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.385
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.48121 0 0 1.55817 310.95 -342.922)",
    d: "M413.302 472.407c.995-3.535 7.855-27.87 7.855-27.87l1.97-4.34m-6.409 30.301c0-.29 6.4-30.27 6.4-30.27m-3.384 27.461c.21-1.27 3.167-22.559 3.167-22.559l.218-4.901",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.267 325.302 4.657.522m-3.587-4.396 4.132.654m-3.056-4.452 3.513.634m-2.536-4.414 3.092.579",
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.55817 326.78 -128.983)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.48121 0 0 1.55817 310.95 -342.922)",
    d: "m420.228 447.356 2.48.553",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.637 323.398 4.518.589m-3.398-4.463 4.132.654m-3.08-4.452 3.512.634m-2.61-4.415 3.092.58",
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.55817 326.78 -128.983)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m404.572 327.21 4.963.514",
    strokeWidth: 0.395,
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.55817 326.78 -128.983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.018 329.119 5.303.504",
    strokeWidth: 0.404,
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.55817 326.78 -128.983)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.48121 0 0 1.54883 311.765 -490.779)",
    d: "m422.381 502.347 9.276 5.285 2.616 6.394",
    strokeWidth: 0.271,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.317,
    style: {
      paintOrder: "markers stroke fill"
    }
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.8014 0 0 1.895 137.946 -491.168)",
    d: "M414.44 468.467c.995-3.536 6.717-23.929 6.717-23.929l1.97-4.342m-6.003 28.989c0-.291 5.995-28.956 5.995-28.956m-3.629 29.159c.211-1.27 3.41-24.258 3.41-24.258l.219-4.901",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.267 325.302 4.657.522m-3.587-4.396 4.132.654m-3.056-4.452 3.513.634m-2.536-4.414 3.092.579",
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.8014 0 0 1.895 157.2 -230.983)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.8014 0 0 1.895 137.946 -491.168)",
    d: "m420.228 447.356 2.48.553",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.637 323.398 4.518.589m-3.398-4.463 4.132.654m-3.08-4.452 3.512.634m-2.61-4.415 3.092.58m-7.231 14.685 4.963.514m-5.517 1.395 5.303.504",
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.8014 0 0 1.895 157.2 -230.983)"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.271
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.48121 0 0 1.54883 311.765 -490.779)",
    d: "M344.354 546.86c11.183-14.063 19.47-27.855 27.419-42.95",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.48121 0 0 1.54883 311.765 -490.779)",
    d: "M326.653 538.99c5.532-3.359 25.724-15.527 37.338-24.97 5.751-4.676 8.081-10.679 8.081-10.679m.868.221c-.291 0 8.575 6.002 8.575 6.002l1.599 6.788m56.391 30.521c-.291 0-33.138-41.326-33.138-41.617 0-.29-9.047-6.81-9.047-6.519l-7.617 9.991",
    style: {
      paintOrder: "markers stroke fill"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      paintOrder: "markers stroke fill"
    }
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.25475 0 0 1.21478 331.373 -190.13)",
    d: "m413.635 471.006 7.58-27.036 2.013-3.776m-7.036 31.609 6.163-27.544.873-4.065m-4.396 31.175 4.788-26.855-.392-4.32m-9.302 27.033 6.102.863",
    style: {
      paintOrder: "markers stroke fill"
    },
    strokeWidth: 0.474
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.154 325.92 5.185.74m-4.065-4.836 4.772.65m-3.737-4.788 4.28.555m-2.989-4.703 3.57.568",
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.25475 0 0 1.1691 375.732 -8.336)",
    strokeWidth: 0.484
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.25475 0 0 1.21478 331.373 -190.13)",
    d: "m419.95 447.418 3.568.624",
    strokeWidth: 0.474,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.951 311.503 3.568.568m-4.744 3.58 4.28.555m-5.519 3.583 4.773.65",
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.25475 0 0 1.1691 375.732 -8.336)",
    strokeWidth: 0.484
  }))), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.618
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.683 262.817s-3.905-1.405-5.913-1.23c-1.944.171-3.47 1.89-5.4 2.165-1.687.24-3.408-.759-5.09-.492-1.544.245-4.269 1.869-4.269 1.869s2.75-.951 4.114-.689c2.016.388 3.149 2.98 5.194 3.185 1.931.194 3.51-2.03 5.45-1.967 2.185.07 5.966 2.606 5.966 2.606z",
    fill: "#fff",
    fillOpacity: 0.996,
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 0.898,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(.8932 0 0 .93398 589.12 43.106)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(883.912 -63.022) scale(.70632)",
    d: "M65.418 496.156c-.136.013-.265.052-.398.076v1.944c-2.329.277-4.006 2.892-6.346 3.035-2.163.132-3.997-2.002-6.162-2.068-1.398-.043-3.575.694-4.88 1.185-.03.018-.075.04-.105.057 1.267-.454 3.47-1.153 4.846-1.012 2.306.237 3.983 2.902 6.3 2.941 2.267.039 3.99-2.587 6.255-2.666l.092.002v1.905c.131-.013.264-.022.398-.018.262.01.974.147 1.267.21v-1.874c2.844.539 6.188 2.53 6.188 2.53l-.002-2.557s-3.42-1.373-6.186-1.58v-2.077c-.295-.06-1.013-.056-1.267-.033z",
    fill: "#a00",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.541
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.48121 0 0 1.54883 324.288 -124.042)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M387.842 262.276h2.411v72.953h-2.411z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6ab87",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M388.247 262.26h1.601v72.984h-1.601z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efc9b2",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M388.667 262.26h.762v72.984h-.762z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.119,
    y: 261.268,
    width: 3.857,
    height: 0.787,
    rx: 0,
    ry: 0,
    fill: "#dd8b59",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M363.077 266.818h2.411v72.953h-2.411z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.354,
    y: 265.697,
    width: 3.857,
    height: 0.787,
    rx: 0,
    ry: 0,
    fill: "#dd8b59",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6ab87",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M363.574 266.923h1.417v72.743h-1.417z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efc9b2",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M363.958 266.923h.648v72.743h-.648z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#dd8b59",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M413.073 265.655h2.411v72.953h-2.411z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.351,
    y: 264.597,
    width: 3.857,
    height: 0.787,
    rx: 0,
    ry: 0,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    color: "#000",
    fill: "#e6ab87",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M413.479 265.669h1.601v72.984h-1.601z",
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.48121 0 0 1.54883 311.765 -490.779)",
    d: "m332.058 541.487 10.788-2.11 16.432 14.763-13.114 2.075z",
    fill: "none",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 0.271,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    color: "#000",
    fill: "#efc9b2",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M413.898 265.669h.762v72.984h-.762z",
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    style: {
      paintOrder: "markers stroke fill"
    }
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1.25475 0 0 1.21478 1468.897 -191.93)",
    d: "m413.635 471.006 7.58-27.036 2.013-3.776m-7.036 31.609 6.163-27.544.873-4.065m-4.396 31.175 4.788-26.855-.392-4.32m-9.302 27.033 6.102.863",
    style: {
      paintOrder: "markers stroke fill"
    },
    strokeWidth: 0.474
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.154 325.92 5.185.74m-4.065-4.836 4.772.65m-3.737-4.788 4.28.555m-2.989-4.703 3.57.568",
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(-1.25475 0 0 1.1691 1424.538 -10.136)",
    strokeWidth: 0.484
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1.25475 0 0 1.21478 1468.897 -191.93)",
    d: "m419.95 447.418 3.568.624",
    strokeWidth: 0.474,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.951 311.503 3.568.568m-4.744 3.58 4.28.555m-5.519 3.583 4.773.65m-5.448 3.51 4.773.651",
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(-1.25475 0 0 1.1691 1424.538 -10.136)",
    strokeWidth: 0.484
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.48121 0 0 1.54883 311.765 -490.779)",
    d: "M453.302 557.134c-.291-.872-.464-2.437-.557-3.67-.087-1.159-.175-2.337 0-3.487.195-1.283 1.159-3.729 1.159-3.729s-25.289 3.623-25.289 3.914c0-.335-.156 6.885-.156 6.885z",
    fill: "#e98e01",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 0.541,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m439.854 312.355.01 6.577h3.205l-.032-7.119zm-4.648.67-.008 5.907 3.214-.068-.017-6.331zm-4.633 5.907.04-5.059 3.023-.487.12 5.544zm-4.517-.012-.016-4.378 3.026-.542.065 4.932zm-4.656.012.162-3.74 3.01-.463.026 4.198z",
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)",
    fill: "#e9b001",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 0.541
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 0.541
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.48121 0 0 1.54883 311.765 -490.779)",
    d: "M342.167 538.16c0 .872 3.722 18.638 3.722 18.638.078.335 1.296.451 1.181-.333-.042-.287-4.003-18.361-4.003-18.361-.454-.42-.446-.125-.9.056z",
    fill: "#dd8b59",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.442 303.82 24.465 10.784-.078 1.053-24.352-10.398-8.886-4.968 8.851 3.53z",
    fill: "#dd8b59",
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.48121 0 0 1.54883 311.765 -490.779)",
    d: "M362.44 523.324s-3.799 2.74-2.927 7.973 4.656 8.237 4.946 8.237c.29 0 3.901-3.662 7.39-4.534 3.488-.873 12.226-.36 12.226-.36s-4.45-4.626-3.577-8.986c.872-4.361 4.292-8.099 4.292-8.099s-21.478 5.769-22.35 5.769z",
    fill: "#fec618",
    style: {
      paintOrder: "markers stroke fill"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.48121 0 0 1.54883 311.765 -490.779)",
    d: "m452.876 544.548-18.022-28.487",
    fill: "none",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 0.271,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.48121 0 0 1.54883 311.765 -490.779)",
    d: "M388.346 518.387c0 .581-3.928 4.829-3.685 9.523.229 4.434 3.198 11.15 3.489 11.15s4.896-4.646 8.675-5.518c3.778-.872 12.9.251 12.61.251-.29 0-3.234-7.32-3.234-10.517 0-3.198 4.804-11.007 4.804-11.007z",
    fill: "#fec618",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 0.541,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.596 281.13c-4.772 1.128-16.548 3.885-22.076 4.987-.398 1.136-.713 2.303-.717 3.197-.006 1.388-.232 3.223.2 4.988l21.4-4.884c-.388-1.175-.647-2.344-.556-3.295.126-1.305.891-3.199 1.749-4.992z",
    fill: "#fed65b",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m398.794 282.927-21.901 4.737c-.147.594-.35 1.167-.353 1.65-.004.942-.256 2.091.054 3.285l21.381-4.745c-.12-.618-.178-1.209-.128-1.73.084-.87.458-2.007.947-3.197z",
    fill: "#fedf82",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4716 -.1685 .1762 1.53877 277.074 -55.747)"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(.99572 .08841 -.09667 .99572 28.306 -28.34)",
    width: "100%",
    height: "100%",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.541,
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.67942 -.0362 .03785 .64976 306.232 184.583)",
    d: "m119.614 166.093-.438-1.408-1.474.053 1-1.083-.783-1.25 1.439.324.69-1.303.439 1.408 1.474-.053-1 1.084.783 1.25-1.439-.325z",
    color: "#000",
    fill: "red",
    fillOpacity: 0.996,
    stroke: "#512007",
    strokeOpacity: 0.996,
    strokeWidth: 0.813,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.67942 -.0362 .03785 .64976 294.858 185.692)",
    d: "m119.614 166.093-.438-1.408-1.474.053 1-1.083-.783-1.25 1.439.324.69-1.303.439 1.408 1.474-.053-1 1.084.783 1.25-1.439-.325z",
    color: "#000",
    fill: "red",
    fillOpacity: 0.996,
    stroke: "#512007",
    strokeOpacity: 0.996,
    strokeWidth: 0.813,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 0.271
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.48121 0 0 1.54883 311.765 -490.779)",
    d: "M413.849 540.101s2.989 9.098 6.181 12.586c1.973 2.156 7.557 4.651 7.557 4.651",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.48121 0 0 1.54883 308.111 -336.699)",
    d: "M390.403 440.301s4.047 17.915 11.024 22.275a952.102 952.102 0 0 1 12.789 8.139",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.48121 0 0 1.54883 308.111 -336.699)",
    d: "M390.462 440.545s7.767 13.311 14.162 17.962c6.395 4.65 15.115 9.011 15.115 9.011m-53.484-27.615c2.034 3.488 1.744 10.174 4.069 12.499 2.325 2.326 5.814 7.558 5.814 7.558",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.48121 0 0 1.54883 308.111 -336.699)",
    d: "M366.836 440.194c1.163 1.744 4.406 10.428 6.395 13.08 1.454 2.326 16.278 17.15 16.278 17.15",
    style: {
      paintOrder: "markers stroke fill"
    }
  })), /*#__PURE__*/React.createElement("path", {
    color: "#000",
    fill: "#dd8b59",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 0.541,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M432.986 300.673h.471v11.355h-.471z",
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.48121 0 0 1.54883 311.765 -490.779)",
    d: "M427.587 551.233c3.198 0 27.324-4.651 27.324-4.651s.872-2.906 0-2.906-27.324 5.523-27.324 5.523z",
    fill: "#e96a01",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 0.541,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#512007",
    strokeOpacity: 0.996,
    color: "#000",
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    transform: "matrix(.673 -.09611 .1005 .64363 291.729 188.469)",
    d: "m119.614 166.093-.438-1.408-1.474.053 1-1.083-.783-1.25 1.439.324.69-1.303.439 1.408 1.474-.053-1 1.084.783 1.25-1.439-.325z",
    colorRendering: "auto",
    fill: "red",
    fillOpacity: 0.996,
    imageRendering: "auto",
    shapeRendering: "auto",
    stroke: "#512007",
    strokeOpacity: 0.996,
    strokeWidth: 0.813,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.66993 -.11412 .11932 .64068 289.015 200.42)",
    d: "m119.614 166.093-.438-1.408-1.474.053 1-1.083-.783-1.25 1.439.324.69-1.303.439 1.408 1.474-.053-1 1.084.783 1.25-1.439-.325z",
    fill: "red",
    fillOpacity: 0.996,
    strokeWidth: 0.813,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.351,
    y: 264.597,
    width: 3.857,
    height: 0.787,
    rx: 0,
    ry: 0,
    fill: "#dd8b59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.541,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 0.541
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.154 275.569c-.23.602 1.54 1.923 2.92 1.814s1.73-1.157 2.093-1.627c.322.56.876 2.971 4.396 1.817 2.919-1.073 2.679-2.794 3.089-3.188.251.068.711.649 1.348.672 2.506.095 4.672-4.166 4.397-4.145-.276.022-17.668 4.904-18.243 4.657z",
    fill: "#fec618",
    fillRule: "evenodd",
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.43443 -.3862 .4014 1.49088 323.943 -124.042)",
    color: "#000",
    fill: "#dd8b59",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M315.065 367.106h19.723v.981h-19.723z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.682 273.515s1.06 1.999 2.892 1.779c1.83-.22 1.851-2.083 1.851-2.083s1.102 2.867 3.946 2.26c2.843-.608 3.511-3.611 3.511-3.611s1.451 1.963 3.702.895c2.251-1.069 3.113-4.182 2.85-4.151-.26.031-18.752 4.911-18.752 4.911z",
    fill: "#fec618",
    fillRule: "evenodd",
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.43443 -.3862 .4014 1.49088 323.943 -124.042)",
    color: "#000",
    fill: "#dd8b59",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M291.353 358.737h19.723v.981h-19.723z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.231 277.698c-.478.324.107 2.122 2.097 2.019 2.501-.286 2.724-2.612 2.724-2.612s.715 3.268 3.86 2.638c3.143-.63 4.806-4.829 4.806-4.829s.08 1.585 2.207 1.337c2.229-.592 2.568-3.217 2.568-3.217-6.057 1.602-12.169 3.088-18.262 4.664z",
    fill: "#fec618",
    fillRule: "evenodd",
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.43443 -.3862 .4014 1.49088 323.943 -124.042)",
    color: "#000",
    fill: "#dd8b59",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M266.32 356.808h19.723v.981H266.32z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.541,
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.683 262.817s-3.905-1.405-5.913-1.23c-1.944.171-3.47 1.89-5.4 2.165-1.687.24-3.408-.759-5.09-.492-1.544.245-4.269 1.869-4.269 1.869s2.75-.951 4.114-.689c2.016.388 3.149 2.98 5.194 3.185 1.931.194 3.51-2.03 5.45-1.967 2.185.07 5.966 2.606 5.966 2.606z",
    fill: "#fff",
    fillOpacity: 0.996,
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(812.8 -300.036) scale(1.1713)",
    d: "M65.418 496.156c-.136.013-.265.052-.398.076v1.944c-2.329.277-4.006 2.892-6.346 3.035-2.163.132-3.997-2.002-6.162-2.068-1.398-.043-3.575.694-4.88 1.185-.03.018-.075.04-.105.057 1.267-.454 3.47-1.153 4.846-1.012 2.306.237 3.983 2.902 6.3 2.941 2.267.039 3.99-2.587 6.255-2.666l.092.002v1.905c.131-.013.264-.022.398-.018.262.01.974.147 1.267.21v-1.874c2.844.539 6.188 2.53 6.188 2.53l-.002-2.557s-3.42-1.373-6.186-1.58v-2.077c-.295-.06-1.013-.056-1.267-.033z",
    fill: "#a00",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.618,
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.683 262.817s-3.905-1.405-5.913-1.23c-1.944.171-3.47 1.89-5.4 2.165-1.687.24-3.408-.759-5.09-.492-1.544.245-4.269 1.869-4.269 1.869s2.75-.951 4.114-.689c2.016.388 3.149 2.98 5.194 3.185 1.931.194 3.51-2.03 5.45-1.967 2.185.07 5.966 2.606 5.966 2.606z",
    fill: "#fff",
    fillOpacity: 0.996,
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.29798 0 0 1.35724 358.278 -66.333)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(786.662 -220.556) scale(1.0264)",
    d: "M65.418 496.156c-.136.013-.265.052-.398.076v1.944c-2.329.277-4.006 2.892-6.346 3.035-2.163.132-3.997-2.002-6.162-2.068-1.398-.043-3.575.694-4.88 1.185-.03.018-.075.04-.105.057 1.267-.454 3.47-1.153 4.846-1.012 2.306.237 3.983 2.902 6.3 2.941 2.267.039 3.99-2.587 6.255-2.666l.092.002v1.905c.131-.013.264-.022.398-.018.262.01.974.147 1.267.21v-1.874c2.844.539 6.188 2.53 6.188 2.53l-.002-2.557s-3.42-1.373-6.186-1.58v-2.077c-.295-.06-1.013-.056-1.267-.033z",
    fill: "#a00",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#dd8b59",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 0.541,
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.43443 -.3862 .4014 1.49088 323.943 -124.042)",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M261.207 364.593h25.51v1.269h-25.51zm26.818 1.625h25.51v1.269h-25.51z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.43443 -.3862 .4014 1.49088 323.943 -124.042)",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M288.025 366.218h25.51v1.269h-25.51zm19.341 28.401h19.723v.981h-19.723z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.43443 -.3862 .4014 1.49088 323.943 -124.042)",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M307.366 394.619h19.723v.981h-19.723z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(812.8 -300.036) scale(1.1713)",
    d: "M21.125 565.715a2.375 2.375 0 0 0-1.074 4.494c-.067.22-.1.447-.102.676a2.37 2.37 0 0 0 2.174 2.36 2.368 2.368 0 0 0-.014.247c0 1.312 1.32 2.375 2.632 2.375 1.027 0 1.437-.885 1.743-1.024l3.065 1.09c-1.347 2.807 9.148 43.71 51.92 41.518 42.233-2.165 50.885-41.566 50.885-41.566s-19.023-.219-19.391-.219c-.367 0-14.705 18.451-33.084 18.066-18.38-.384-24.26-4.997-28.305-8.84-4.043-3.843-7.719-9.609-7.719-9.609l-21.105-9.088c-1.419-.454-.892-.48-1.625-.48z",
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 0.7,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.46 339.321c-9.839-.78-19.23-3.926-24.24-8.459-1.718-1.554-3.385-3.519-3.85-4.991-.179-.568-.212-1.388-.28-1.467-.069-.079-2.067-.58-4.317-1.231-6.215-1.8-5.956-1.923-6.622-2.21-.143-.327-.391-1.074-.493-1.074s-.321-.05-.488-.11c-.192-.071-.302-.013-.302.16 0 .15.172.316.382.368.508.127.517.962.013 1.22-.615.315-1.289.214-1.908-.284-.69-.555-.773-1.12-.177-1.204.61-.087 1.194-.929 1.043-1.504-.081-.31-.255-.473-.503-.473-.463 0-.482.16-.054.46.304.213.304.256-.004.706-.601.877-2.049.572-2.532-.535-.36-.824-.366-.813.382-.813.36 0 .792-.051.962-.114.434-.16.911-1.113.77-1.54-.12-.36-.857-.51-.857-.173 0 .1.086.182.191.182.299 0 .225.673-.109.992-.748.715-2.381-.018-2.413-1.084a3.376 3.376 0 0 1 .12-.96c.151-.454 1.011-.957 1.637-.957.522 0 17.82 7.106 17.997 7.393.802 1.301 4.081 5.158 5.678 6.678 3.494 3.327 6.638 4.914 11.896 6.003 4.849 1.005 12.617 1.343 15.72.685 3.758-.798 7.365-2.285 10.792-4.451 2.896-1.83 4.721-3.265 7.662-6.026l2.6-2.44 1.864.052 1.864.053-1.102 1.37c-6.79 8.44-14.706 13.8-22.677 15.354-1.913.373-6.47.596-8.644.424z",
    color: "#000",
    fill: "#fecf3e",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 0.385
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1.48121 0 0 1.55817 1490.048 -343.74)",
    d: "M413.684 471.046c.995-3.536 7.473-26.508 7.473-26.508l1.97-4.342m-6.027 28.941c0-.291 6.019-28.908 6.019-28.908m-3.003 26.098c.21-1.27 2.785-21.197 2.785-21.197l.218-4.901",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.267 325.156 4.657.523m-3.587-4.454 4.132.655m-3.056-4.368 3.513.634m-2.536-4.347 3.092.579",
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(-1.48121 0 0 1.55817 1474.216 -129.801)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1.48121 0 0 1.55817 1490.048 -343.74)",
    d: "m420.228 447.356 2.48.553",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.637 323.277 4.657.523m-3.537-4.36 4.132.654m-3.08-4.391 3.512.634m-2.61-4.371 3.092.58",
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(-1.48121 0 0 1.55817 1474.216 -129.801)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M355.552 304.616c-.478.323.108 2.122 2.098 2.018 2.5-.285 2.723-2.017 2.723-2.017s1.053 2.433 4.197 1.803c3.143-.63 4.47-3.995 4.47-3.995s.08.992 2.206.744c2.229-.592 2.569-3.217 2.569-3.217-6.058 1.602-12.17 3.088-18.263 4.664z",
    fill: "#fec618",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 0.541,
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.43443 -.3862 .4014 1.49088 323.943 -124.042)",
    color: "#000",
    fill: "#dd8b59",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 0.541,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M256.258 382.41h25.51v1.269h-25.51z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      paintOrder: "markers stroke fill"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.683 262.817s-3.905-1.405-5.913-1.23c-1.944.171-3.47 1.89-5.4 2.165-1.687.24-3.408-.759-5.09-.492-1.544.245-4.269 1.869-4.269 1.869s2.75-.951 4.114-.689c2.016.388 3.149 2.98 5.194 3.185 1.931.194 3.51-2.03 5.45-1.967 2.185.07 5.966 2.606 5.966 2.606z",
    color: "#000",
    fill: "#fec618",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 1.204,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(.66587 0 0 .69627 707.14 158.657)"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.48121 0 0 1.54883 311.765 -490.779)",
    d: "M412.804 521.222s-2.315 4.721-2.327 7.249c-.017 3.763 3.073 10.821 3.364 10.821s4.773-4.633 8.261-4.924 11.227-.21 11.227-.21-3.288-5.68-2.997-8.878c.29-3.198 4.184-9.977 4.184-9.977z",
    fill: "#fec618",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 0.541,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.43443 -.3862 .4014 1.49088 323.943 -124.042)",
    fill: "#dd8b59",
    strokeWidth: 0.541,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M309.91 375.046h25.51v1.269h-25.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.237 321.831c1.019-.48.84-1.823-.258-1.782m-4.319-2.449c2.458 1.047 2.84-1.845 1.852-1.504m-.226 3.889c2.005.303 2.115-2.015 1.188-1.671",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)",
    fill: "none",
    strokeWidth: 0.271
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 0.317,
    style: {
      paintOrder: "markers stroke fill"
    }
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1.8014 0 0 1.895 1662.537 -490.991)",
    d: "M414.44 467.944c.995-3.535 6.717-23.406 6.717-23.406l1.97-4.342m-6.121 28.205c0-.29 6.113-28.172 6.113-28.172m-3.511 28.375c.21-1.27 3.293-23.474 3.293-23.474l.218-4.901",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.267 325.302 4.657.522m-3.587-4.396 4.132.654m-3.056-4.452 3.513.634m-2.536-4.414 3.092.579",
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(-1.8014 0 0 1.895 1643.284 -230.806)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1.8014 0 0 1.895 1662.537 -490.991)",
    d: "m420.228 447.356 2.48.553",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.637 323.398 4.518.589m-3.398-4.463 4.132.654m-3.08-4.452 3.512.634m-2.61-4.415 3.092.58m-7.231 14.685 4.963.514m-5.517 1.395 5.303.504",
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(-1.8014 0 0 1.895 1643.284 -230.806)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M380.202 303.726s1.168 2.204 3.188 1.961c2.018-.242 2.041-2.296 2.041-2.296s1.215 3.161 4.35 2.492c3.134-.67 3.87-3.982 3.87-3.982s1.6 2.165 4.082.987c2.482-1.178 3.432-4.61 3.143-4.576-.288.035-20.674 5.414-20.674 5.414z",
    fill: "#fec618",
    fillRule: "evenodd",
    strokeWidth: 0.541,
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.43443 -.3862 .4014 1.49088 323.943 -124.042)",
    color: "#000",
    fill: "#dd8b59",
    strokeWidth: 0.541,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M281.439 387.928h25.51v1.269h-25.51z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.48121 0 0 1.54883 311.765 -490.779)",
    d: "M413.586 539.943s1.787 11.317 4.99 15.941c1.667 2.407 6.977 5.523 6.977 5.523",
    fill: "none",
    strokeWidth: 0.271,
    style: {
      paintOrder: "markers stroke fill"
    }
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 0.541
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.302 303.976c-.23.602 1.54 1.923 2.92 1.813s1.73-1.156 2.094-1.626c.321.56.875 2.971 4.395 1.816 2.919-1.072 2.68-2.793 3.09-3.187.25.067.71.648 1.347.672 2.507.094 4.673-4.167 4.397-4.145-.276.022-17.667 4.903-18.243 4.657z",
    fill: "#fec618",
    fillRule: "evenodd",
    style: {
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.43443 -.3862 .4014 1.49088 323.943 -124.042)",
    color: "#000",
    fill: "#dd8b59",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    d: "M304.496 394.392h25.51v1.269h-25.51z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.48121 0 0 1.54883 311.765 -490.779)",
    d: "m426.425 558.5 27.871.582c.516-1 .33-1.553.034-2.035l-27.894-.291z",
    fill: "#e96a01",
    fillRule: "evenodd",
    style: {
      paintOrder: "markers stroke fill"
    }
  })), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.43454 -.38572 .88164 1.24459 323.943 -124.042)",
    d: "M109.962 412.884h24.746l-.255.719-24.76-.004z",
    fill: "#e6ab87",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.468 304.475 23.38-6.041.123.46-23.433 5.977z",
    fill: "#efc9b2",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.388 285.97 23.966-6.164.181.642-23.983 6.163z",
    fill: "#e6ab87",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.603 286.05 23.38-6.041.124.46-23.433 5.977z",
    fill: "#efc9b2",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.17 277.17 18.096-4.654.137.485-18.109 4.653z",
    fill: "#e6ab87",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.333 277.23 17.654-4.56.092.347-17.692 4.512z",
    fill: "#efc9b2",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.983 272.725 18.096-4.654.137.485-18.109 4.653z",
    fill: "#e6ab87",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.146 272.786 17.653-4.562.093.348-17.693 4.512z",
    fill: "#efc9b2",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.076 274.964 18.095-4.654.137.485-18.109 4.654z",
    fill: "#e6ab87",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.238 275.025 17.654-4.562.092.348-17.692 4.512z",
    fill: "#efc9b2",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.634 280.856 23.966-6.163.18.642-23.983 6.163z",
    fill: "#e6ab87",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.849 280.937 23.38-6.042.123.46-23.433 5.977z",
    fill: "#efc9b2",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.328 283.93 23.966-6.162.181.641-23.983 6.164z",
    fill: "#e6ab87",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.543 284.012 23.38-6.042.124.46-23.433 5.977z",
    fill: "#efc9b2",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.04 303.436 23.967-6.164.18.642-23.983 6.163z",
    fill: "#e6ab87",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.256 303.516 23.38-6.041.123.46-23.433 5.977z",
    fill: "#efc9b2",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(812.8 -300.036) scale(1.1713)",
    d: "M54.668 528.27c-5.508 1.426-18.402 4.753-27.715 7.07a12.034 12.034 0 0 0-.076 4.355 18.082 18.082 0 0 0 1.682 5.217l25.843-6.293c-.85-1.941-1.409-4.187-.988-6.385.266-1.389.72-2.729 1.254-3.964z",
    fill: "#fed65b",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(812.8 -300.036) scale(1.1713)",
    d: "M54.033 529.918c-3.345.883-19.28 5.085-27.295 7.098-.045.831-.014 1.72.139 2.68a18.012 18.012 0 0 0 1.195 4.154l25.852-6.465c-.557-1.63-.844-3.405-.51-5.15.151-.792.366-1.567.62-2.317z",
    fill: "#fedf82",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(812.8 -300.036) scale(1.1713)",
    d: "M118.52 525.139c-5.694 1.49-19.743 5.136-26.338 6.593-.475 1.502-.85 3.046-.856 4.227-.008 1.835.521 4.262 1.207 6.596l24.563-6.457c-.463-1.554-.772-3.1-.662-4.358.15-1.725 1.062-4.23 2.086-6.601z",
    fill: "#fed65b",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(812.8 -300.036) scale(1.1713)",
    d: "m117.563 527.514-25.93 6.263c-.175.786-.304 1.544-.307 2.182-.005 1.246.235 2.766.606 4.344l24.654-6.274c-.143-.818-.212-1.599-.152-2.289.1-1.149.546-2.653 1.128-4.226z",
    fill: "#fedf82",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.205 303.892 23.966-6.163.18.642-23.983 6.163z",
    fill: "#e6ab87",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.42 303.973 23.38-6.041.123.46-23.432 5.976z",
    fill: "#efc9b2",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#520",
    fillRule: "evenodd",
    stroke: "#2b1100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996,
    strokeWidth: 0.541,
    transform: "matrix(1.48121 0 0 1.54883 323.943 -124.042)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 391.065,
    cy: 337.37,
    rx: 0.955,
    ry: 0.913,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.135)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 367.833,
    cy: 328.845,
    rx: 0.955,
    ry: 0.913,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 414.568,
    cy: 328.845,
    rx: 0.955,
    ry: 0.913,
    style: {
      paintOrder: "markers stroke fill"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.101)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 376.545,
    cy: 334.399,
    rx: 0.955,
    ry: 0.913,
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 405.788,
    cy: 334.399,
    rx: 0.955,
    ry: 0.913,
    style: {
      paintOrder: "markers stroke fill"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#512007",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.996
  }, /*#__PURE__*/React.createElement("path", {
    d: "m288.864 682.347 8.903 2.593c2.214 10.233 21.926 16.04 34.514 14.994 10.772-.896 19.986-8.545 26.775-17.513",
    strokeWidth: 0.232,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 419.01 -682.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.071 684.503c.63 6.791 9.553 18.81 33.508 18.81 23.2 0 32.449-21.02 32.449-21.02",
    strokeWidth: 0.232,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 419.01 -682.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.562 683.837c.728 7.865 8.265 24.187 36.005 24.187 26.866 0 36.456-25.455 36.456-25.455",
    strokeWidth: 0.269,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 419.01 -682.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.315 683.184c-.235 5.794 8.842 29.466 38.189 29.072 26.032-.35 36.788-23.303 39.244-29.58",
    strokeWidth: 0.301,
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    },
    transform: "matrix(1.48121 0 0 1.54883 419.01 -682.25)"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.036
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(812.8 -300.036) scale(1.1713)",
    d: "M76.119 603.372c-10.499-.62-19.12-3.183-25.908-7.705-1.995-1.328-3.172-2.286-4.872-3.964-3.572-3.525-5.928-7.566-6.727-11.536-.111-.552-.175-1.031-.142-1.064.033-.033.438.055.9.195l.84.255.143.628c.213.944.878 2.479 1.563 3.607 1.676 2.762 4.456 5.415 8.037 7.67 1.616 1.019 5.287 2.85 7.324 3.655 9.517 3.76 21.086 5.34 29.168 3.982 8.089-1.358 15.888-5.787 23.373-13.272 2.764-2.764 4.684-4.98 7.252-8.368l.911-1.203 1.561.02c.858.011 1.582.042 1.608.068.027.026-.317.742-.764 1.59-2.2 4.183-5.287 8.426-8.758 12.041-7.57 7.887-16.934 12.458-27.357 13.357-1.311.113-6.503.14-8.152.043z",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(812.8 -300.036) scale(1.1713)",
    d: "M78.111 609.655c-6.284-.184-12.522-1.22-17.573-2.918-2.522-.847-3.542-1.27-5.919-2.456-7.46-3.721-12.831-9.023-16.314-16.105-1.52-3.09-2.613-6.566-2.955-9.396l-.085-.7.315.078c.173.044.788.225 1.367.403l1.052.324.166 1.022c.091.562.375 1.653.63 2.423 2.301 6.943 8.624 13.18 17.207 16.972 3.937 1.74 8.866 3.115 13.775 3.844 5.059.75 11.917.934 16.09.43 11.407-1.375 21.438-7.22 29.37-17.112 2.143-2.674 4.067-5.612 5.55-8.475l.896-1.733 2.31.086c1.271.048 2.324.098 2.34.113.064.054-.989 2.36-1.906 4.174-2.087 4.127-4.685 8.058-7.782 11.775-1.519 1.823-4.791 5.105-6.507 6.525-7.08 5.864-14.81 9.275-23.511 10.375-1.603.203-5.652.446-6.764.406-.366-.013-1.154-.038-1.752-.055z",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(812.8 -300.036) scale(1.1713)",
    d: "M76.904 615.222c-8.056-.476-14.235-2.017-20.397-5.085-8.295-4.13-15.157-10.833-19.701-19.243-1.828-3.384-3.4-7.495-3.97-10.388-.328-1.663-.506-3.26-.363-3.26.05 0 .593.145 1.206.322l1.115.322.076.614c.278 2.252.986 5.024 1.837 7.196 3.676 9.383 10.975 16.482 21.113 20.534 4.658 1.861 9.782 3.024 16.064 3.645 2.525.25 10.334.213 12.44-.059 9.606-1.238 17.72-4.943 25.197-11.504 1.456-1.277 4.091-3.987 5.424-5.577 3.776-4.505 7.385-10.311 9.41-15.139l.478-1.14h1.386c.763 0 1.425.04 1.473.088.228.228-2.791 6.764-4.564 9.877-5.05 8.87-11.382 15.954-18.572 20.779-6.68 4.481-13.953 7.07-22.043 7.845-1.392.134-6.364.246-7.61.173z",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(812.8 -300.036) scale(1.1713)",
    d: "M74.67 617.385c-4.251-.303-7.721-.892-11.305-1.92-12.458-3.574-22.62-12.13-29.203-24.59-2.357-4.462-4.411-10.49-4.63-13.584l-.071-1.01.591.181c.326.1.872.266 1.214.367l.622.185.084.992c.416 4.929 3.051 11.514 6.874 17.175 7.647 11.326 19.272 18.36 33.226 20.106 19.116 2.39 35.295-4.28 47.39-19.542 3.911-4.934 7.67-11.379 10.085-17.292l.764-1.872.92-.035.92-.035-.183.639c-1.147 4.005-3.302 9.022-5.583 12.998-6.149 10.716-14.873 18.575-25.559 23.025-5.539 2.307-11.687 3.697-18.427 4.168-1.593.112-6.4.139-7.73.044z",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "translate(812.8 -300.036) scale(1.1713)",
    d: "M76.63 603.33c-11-.562-20.183-3.37-27.259-8.336-3.802-2.668-7.156-6.429-8.977-10.065-.95-1.899-1.807-4.482-1.81-5.458v-.323l.694.19c.382.105.738.23.792.276.053.047.178.405.277.797.269 1.061 1.494 3.482 2.35 4.642 2.032 2.753 5.206 5.389 8.991 7.464 7.607 4.171 17.382 6.746 26.934 7.095 9.992.365 18.368-2.711 27.116-9.958 1.869-1.548 6.895-6.59 8.497-8.523.712-.86 1.85-2.286 2.528-3.17l1.234-1.61h3.083l-.6 1.196c-3.45 6.874-9.708 14.091-15.962 18.41-5.54 3.825-11.826 6.247-18.379 7.082-1.816.231-7.359.4-9.51.29z",
    fill: "#fec413",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(812.8 -300.036) scale(1.1713)",
    d: "M78.441 609.605c-7.172-.229-13.521-1.358-19.325-3.438-1.796-.643-5.424-2.395-7.389-3.567-3.8-2.268-7.336-5.417-9.892-8.81-2.57-3.413-4.747-7.874-5.767-11.822-.351-1.357-.787-3.684-.705-3.765.02-.02.604.13 1.296.335l1.26.372.21 1.07c.628 3.204 2.257 6.608 4.536 9.476 2.993 3.768 7.723 7.347 12.707 9.616 7.063 3.216 15.238 4.813 24.652 4.817 3.44 0 5.375-.134 7.785-.542 10.089-1.709 18.98-6.918 26.236-15.368 2.77-3.226 5.341-7.044 7.079-10.51l.56-1.117 1.055.014c.58.008 1.61.05 2.288.09l1.231.077-.42.966c-.776 1.784-2.424 4.955-3.551 6.833-2.926 4.876-6.44 9.243-10.402 12.923-7.316 6.8-16.211 10.96-25.653 12.002-1.778.196-5.739.448-6.385.406a64.04 64.04 0 0 0-1.406-.058z",
    fill: "#e9b001",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(812.8 -300.036) scale(1.1713)",
    d: "M74.052 614.94c-6.304-.685-11.048-1.91-15.927-4.116-8.674-3.92-15.848-10.511-20.758-19.071-1.526-2.662-3.14-6.42-3.926-9.15-.465-1.612-.897-3.906-.897-4.762 0-.493.022-.533.254-.459.14.044.609.182 1.043.306.434.124.81.247.836.273.026.026.128.558.227 1.182.55 3.459 1.503 6.394 3.136 9.65 1.772 3.532 3.854 6.34 6.899 9.303 7.55 7.346 18.528 11.453 31.99 11.969 7.32.28 12-.242 17.637-1.967 9.172-2.808 17.83-9.119 24.344-17.745 2.948-3.904 5.91-8.915 7.472-12.643l.52-1.238h.451c.248 0 .869.036 1.378.079 1.092.092 1.087-.158.049 2.277-1.62 3.797-4.33 8.852-6.41 11.953-7.378 11-16.435 18.325-27.102 21.918-2.926.986-5.723 1.624-9.338 2.13-1.957.274-9.71.346-11.877.11z",
    fill: "#e98e01",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(812.8 -300.036) scale(1.1713)",
    d: "M75.24 617.346c-4.915-.366-8.115-.892-11.74-1.928-7.38-2.111-13.783-5.826-19.327-11.214-4.236-4.116-7.656-8.804-10.355-14.195-2.236-4.465-3.904-9.524-4.23-12.832l-.08-.806 1.088.326c.599.179 1.118.354 1.153.39.035.035.123.604.195 1.264.36 3.314 1.698 7.451 3.704 11.457 5.198 10.38 13.782 18.326 24.253 22.452 6.065 2.39 12.288 3.511 19.507 3.515 4.62.003 8.09-.388 12.11-1.363 11.092-2.692 20.586-9.106 28.447-19.218 1.475-1.898 3.802-5.375 5.214-7.79 1.26-2.156 3.53-6.734 4.464-9l.722-1.75.848-.036.847-.035-.177.579c-.098.318-.235.786-.305 1.04-.07.255-.395 1.195-.723 2.09-3.08 8.42-7.749 15.892-13.58 21.73-8.763 8.772-19.7 13.774-32.976 15.082-1.746.172-7.818.335-9.058.242z",
    fill: "#d05f01",
    style: {
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers stroke fill"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFk);
export default __webpack_public_path__ + "static/media/fk.d91271ffd9f983cc1339ab1c935ae313.svg";
export { ForwardRef as ReactComponent };